'use strict';

exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      year: '',
      month1: 'Jan',
      month2: 'Feb',
      month3: 'Mar',
      month4: 'Apr',
      month5: 'May',
      month6: 'Jun',
      month7: 'Jul',
      month8: 'Aug',
      month9: 'Sep',
      month10: 'Oct',
      month11: 'Nov',
      month12: 'Dec',
      // week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    mypagination: {
      total: "Total",
      tiao: '',
      next: 'Next',
      prev: 'Prev'

    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    }
  },
  share: {
    "year": "Year",
    "month": 'Month',
    "day1": 'day',
    "day": 'day',
    "hour": 'Hour',
    "minutes": 'Minutes',
    "seconds": 'Seconds',
    "download": 'Download',
    "upload": 'Upload',
    "english": 'English',
    "chinese": 'Chinese',
    "logLevel": "Log level",
    // "selectDate": "select date",
    "all": "ALL",
    "unassigned": "Unassigned",
    "assigned": "Assigned",
    "unassigned1": "Unassigned",
    "assigned1": "Assigned",
    "queryMac": "MAC",
    "autoAssign": "Auto Assign",
    "clone": "Replicate config",
    "close": "Close",
    "add": "New",
    "mod": "Edit",
    "del": "Delete",
    "save": "Save",
    "cue": "Note",
    "confirm": "Ok",
    "cancel": "Cancel",
    "delConfirm": "It will be deleted permanently,do you want to continue?",
    "cancelDel": "Canceled",
    "select": "Please select",
    "search": "Search",
    "refreshOk": "Refreshed successfully",
    "getFile": "Choose file",
    "fileName": "File name",
    "selectFile": "Please choose a file to import",
    "upFile": "Click to choose a file to upload",
    "import": "Import",
    "export": "Export",
    "refresh": "Refresh",
    "inputPw": "Enter the password",
    "inputOldPw": "Enter the old password",
    "oldPassErr": "The old password is incorrect",
    "inputConfirmPw": "Enter the password again",
    "confirmPwErr": "Verify your password again",
    "uploadOk": "File uploaded successfully.",
    "uploadFail": "Failed to upload file",
    "info": "Details",
    "selectDate": "Choose a date",
    "searchType": "Choose a searching method",
    "status": "Status",
    "suc": "Success",
    "fail": "Failure",
    "enable": "Enable",
    "canceled": "Canceled",
    "all": "All",
    "default": "Default",
    "default1": "default",
    "check": "View",
     "checktoken": "View token",
    "ops": "Operation succeeded.",
    "opf": "Operation failure",
    "inprogress": "Synchronizing",
    "titleDes": "The cloud accounts help to import the devices exist on the Cloud Server to the UMS.",
    "domainDes": "Domain defines the root directory of a device in 'Device' > 'Device list' page. A device belongs to only a domain.",
    "next": "Next",
    "changeStatus": "Sure you want to change the state?",
    "delData": "This operation will permanently delete and delete the device call monitoring data. Do you want to continue?",
    "operation": 'Operation',
    "return": 'Return',
    "required": 'required',
    "operationCode": 'Operation code:'
  },
  login: {
    "productName": "UMS",
    "username": "Username",
    "password": "Password",
    "titleName": "UMS",
    "copyright": "New Rock Technologies, Inc. 2026. All rights reserved.", //Redstone Systems, Inc. 2022. All rights reserved.
    "login_btn": "Login",
    "login_errormsg": "Failed login attempt",
    "remeberMe": "Remember me",
    "retry": "You have {time} attempts left to log in",
    "versions": "version of system component",
    "release": "Release:",
    "web": "web version:",
    "ums": "UMS version:",
    "umsDevice": "umsdevice version:"
  },
  menu: {
    "management_phoneSource": "Phone numbers",
    "direct_sell": "HXv",
    "device_maintenance": "Maintain",
    "mini": "UMS",
    "monitorPage": 'Monitor website',
    "monitorPage_screen": 'Screen monitoring',
    "monitorPage_device": 'Devices monitoring',
    "device": "Device",
    "device_list": "Device list",
    "device_config": " Configure",
    "device_status": "Status",
    "device_upgrade": "Upgrade",
    "device_deploy": "Deploy ",
    "management": "Manage",
    "management_group": "Device group",
    "management_model": "Template",
    "management_model_om": "OM template",
    "management_model_mx": "MX template",
    "management_model_file": "Clone configurations",
    "management_package": "Upgrade package",
    "management_parameter": "Parameter",
    "management_parameter_mx": "MX parameter",
    "management_parameter_om": "OM parameter",
    "management_user": "User",
    "management_privilege": "Role",
    "management_log": "Operation log",
    "management_parameter_voip": "Parameters",
    "management_model_voip": "Templates",
    "management_config_voip": "Config Files",
    "monitor": "Monitor alarms",
    "alarm": "Alarms",
    "monitoring": "Monitor",
    "event": "Event",
    "task": "Task",
    "system": "System settings",
    "domain": "Domain",
    "cloud": "Cloud",
    "secr": "Cloud account",
    "sysinfo": "System info",
    "dataBackup": "Maintenance",
    "alarmSet": "Alarms-monitored settings",
    "ignoreAlarm": "Ignore unknown events",
    "ignoreAlarm_note": "Enable ‘Ignore unknown events’, the system will not record and monitor unknown events",
    "emailSet": "Mail server settings",
    "phoneSet": "Phone service settings",
    "emailAddr": "Mail server",
    "emailUser": "Account",
    "emailPass": "Password",
    "emailLang": "Email Language",
    "emailsubject":"Email subject",
    "emailSet_note": "Enter the mail server for sending alarm message",
    "devicePassSet": "Set device default password",
    "devPass": "Password",
    "setDevicePassOk": "Device default password set successfully",
    "setEmailOk": "Mail server set successfully",
    "setPhoneOk": "Phone service set successfully",
    "setIgnoreAlarmOk": "Ignore unknown events’ set successfully",
    "emailSecurity": "Connection security",
    "inTesting": "Testing",
    "dierct_sell": "Direct marketing management",
    "device_maintenance": "Diagnosis",
    "sys_alarm": "System monitor",
    "bigScreenConfigure": 'Big screen configuration',

  },
  index: {
    "week": 'Week',
    "meddle": 'Meddle',
    "strong": 'Strong',
    "changePassTitle": "Change Password",
    "changePassNote": "Please change the default password for the security of your system",
    "oldPass": "Old password",
    "newPass": "New password",
    "newPassValid1": "The password must be 8 to 16 characters containing at least three uppercase letters and numbers and symbols, ",
    "newPassValid2": "The password must be 8 to 16 characters/numbers",
    "confirmNewPass": "Confirm password",
    "securitySet": "Security",
    "allowLogin": "Trusted IP addresses for login",
    "ipStart": "Start IP address",
    "ipStartCue": "Enter start IP address",
    "ipCue": "Enter a valid IP address",
    "ipEnd": "End  IP address",
    "description": "Description",
    "createTime": "Creation time",
    "IllegalLogin": "Illegal IP address for login",
    "deadLine": "Expire in",
    "allowLoginTitle": "Enter the trusted IP addresses for login",
    "user-defined": "User-defined",
    "myIP": "My IP address",
    "anyIP": "Any IP address",
    "news": "Most recent message",
    "newDevice": "{count} new devices!",
    "license": "The license will expire in {day} days!",
    "licenseExpirese": "License expired",
    "sysadmin": "System admin",
    "admin": "Admin",
    "logout": "Logout",
    "changePwOk": "Password changed successfully",
    "secGroupAddOk": "Added successfully",
    "secGroupModOk": "Modified successfully",
    "secGroupDelOk": "Deleted successfully",
    "userInfo": "User Info",
    "changeUserInfo": "Change user information",
    "changeUserInfoOK": "User Info changed successfully",
    "OMAdress": "IP address of OM",
    "apiPass": "API password",
    "exdID": "exd ID",
    "menuID": "Menu ID",
    "lineType": "Service provided by",
    "defaultLine": "Redstone",
    "userCreate": "Yourself",
    "testInform": "You can set an email address to test your settings after  saving successfully",
    "sendEmail": "Test",
    "testOk": "Testing email was sent successfully, please check your mailbox.",
    "none": "None",
    "newVersion": "A newer version: {version}！",
    "testFail": "Sending the test email failed",
    "inTesting": "A test email is being sent"
  },
  device: {
    "appVersion": "app version",
    "kernelVersion": "kernel version",
    "Unknown": "Unknown",
    "cancel": "cancel",
    "confirm": "confirm",
    "ip2": "IP",
    "alarms": "Alarms",
    "eventList": "Event",
    "lineStatus": "Line status",
    "model": "Model",
    "all": "All devices",
    "cloud": "Sync from cloud{cloudid}",
    "auto": "Auto discovery",
    "manual": "Add manually",
    "name": "Name",
    "mac": "MAC",
    "proType": "Model",
    "group": "Group",
    "groupBtn": "Group",
    "selectGroup": "Please choose a device group",
    "selecttype": "Please select a device model",
    "addr": "Address",
    "addrCue": "Please enter the zone where the device installed",
    "ip": "Access url",
    "ipCue": "Such as: http://220.123.156.45",
    "pw": "Password",
    "oldPw": "Old password",
    "confirmPw": "Confirm password",
    "contacts": "Contact",
    "contactsCue": "Please enter mobile phone number or landline phone number",
    "status": {
      "label": "Status",
      "online": "Online",
      "offline": "Offline",
      "forbidden": "Forbidden",
      "abnormal": "Incorrect MAC address",
      "fault": "Device  faulty",
      "unreachable": "Device is unreachable",
      "wrongPw": "Incorrect device password",
      "locked": "The device is locked",
      "firstOnline": "Earliest online time:",
      "lastOnline": "Last online time:",
      "lastOffline": "Last offline time:",
      "forbiddenNote": "Please add the IP address of UMS to trust IP address group"
    },
    "inputGroup": "Please enter device group name",
    "inputGroupRule": "Enter 2 to 10 characters",
    "addGroupS": "Device group added successfully",
    "modGroupS": "Device group modified successfully",
    "delGroupS": "Device group deleted successfully",
    "selectCue": "Select a device first",
    "import": "Import",
    "importFile": "Please choose a file to import",
    "addDev": "Please enter the device information",
    "delDevOk": "Device deleted successfully",
    "addDevOk": "Device added successfully",
    "modDevOk": "Device modified successfully",
    "inputDevName": "Please enter device name",
    "inputDevMac": "Please enter device MAC address",
    "inputIp": "Please enter an IP address with completed URL format",
    "validFail": "The device information is invalid, please enter again",
    "queryCloud": "Discovered device from cloud, you can click + to add it to the UMS system",
    "updateGroupOk": "Device group modified successfully",
    "updateGroupFail": "Failed to modify device group. Detailed information:",
    "basicInfo": "Basic information",
    "selectLine": "Please select entity.",
    "editGroup": "Edit Group Name",
    "exportPass": "Do you want to export devices' passwords?",
    "tag1": "tag1",
    "tag2": "tag2",
    "tag3": "tag3",
    "inputTag": "Please enter tag",
    "userDefined": 'User defined',
    "noEdite": 'Not modify',
    "null": "Empty",
    "selectMode": 'Please select',
    "validPass": 'Password Inconsistency',
    "importTemplate": 'Import Template'
  },
  devConf: {
    "selectByList": "Select by list",
    "selectByGroup": "Select by group",
    "accessFail": "The device is offline or device password is incorrect",
    "importTarCue": "Choose a .tar file to import",
    "confTar": "Configuration package",
    "uploadBackTar": "Upload backup package",
    "createFileTmp": "Create file template",
    "backTime": "Backup time",
    "setTimes": "Recover counts",
    "setTime": "Recover time",
    "setResult": "Recover result",
    "setConf": "Recover configuration",
    "set": "Recover",
    "confirm": "Make sure you have backed up the current configurations before submitting new configures. Do you want to continue?",
    "setOk": "Configurations recovered successfully",
    "setFail": "Failed to recovered configurations",
    "backupOk": "Configurations backed up successfully",
    "setDecsOk": "Description modified successfully",
    "downlogCue": "Please choose a log level",
    "logLevel": "Log level",
    "selectDownlog": "Please choose the log to download",
    "logTime": "Log date",
    "logTimeCue": "Please choose the log date",
    "logFile": "log file",
    "downlog": "Download history log",
    "downCurLog": "Download current log",
    "log1": "1 (System information)",
    "log3": "3 (DSP instruction)",
    "log4": "4 (DSP event)",
    "log5": "5 (Call information)",
    "log6": "6 (RTP event)",
    "log8": "8 (Registrar information)",
    "modLogLevelOk": "Log level modified successfully. It takes affect after a reboot",
    "downlogOk": "Log downloaded successfully",
    "BackupInfo": "Detailed backup information",
    "backupId": "Backup ID",
    "paramID": "Parameter ID",
    "paramName": "Parameter name",
    "chName": "Chinese name",
    "enName": "English name",
    "paramVal": "Parameter value",
    "opTime": "Operting time",
    "confCompare": "Compare configurations",
    "lineId": "ID",
    "type": "Type",
    "template": "Template",
    "backupTem": "Backup parameter template",
    "backupTem": "Backup parameter",
    "version": "Version",
    "compareRule": "Only two objects can be compared",
    "alarmInfo": "Alarm information",
    "event": "Event",
    "createTime": "Creation time",
    "callStatus": "Call status",
    "accAddr": "Please enter the device IP address to access",
    "extInfo": "Please enter extension information",
    "record": "Recording",
    "number": "Number",
    "displayName": "Display name",
    "email": "Email",
    "phoneNumber": "Mobile phone",
    "lineInfo": "Please enter subscriber line information",
    "allRecord": "Recording",
    "callWaiting": "Call waiting",
    "callHold": "Call hold",
    "callForward": "Call transfer by calling party",
    "callerID": "Caller ID",
    "outgoingBar": "Outgoing call barring",
    "reg": "Registration",
    "username": "Username",
    "pw": "Password",
    "trunkInfo": "Please enter trunk information",
    "revPolDetec": "Polarity reversal detection",
    "callerIdDetec": "Caller ID detection",
    "DIDNumber": "DID number",
    "fxoInput": "Please enter trunk information",
    "ring-back": "Echo cancellation",
    "delaySend": "Connect signal delay",
    "accType": "Inbound route",
    "bind": "Binding",
    "secDailing": "Second stage dialing",
    "did": "Direct",
    "bindNum": "Binding number",
    "voicePrompt": "Voice prompt",
    "dailToneHint": "Dialing tone",
    "loginDev": "Login devices",
    "reset": "Restore factory settings",
    "callOutSta": "Outgoing call status",
    "devAlarm": "Alarm",
    "devPw": "Device password",
    "wan": "WAN IP address",
    "lan": "LAN IP address",
    "autoUp": "Auto upgrade",
    "startTime": "Startup time",
    "runTime": "Up time",
    "ext": "Extension",
    "fxs": "FXS",
    "trunk": "Trunk",
    "fxo": "FXO",
    "ipExt": "IP extension",
    "sipTrunk": "SIP trunk",
    "route": "Routing",
    "digitmap": "Digitmap",
    "confTarM": "Configuration packages",
    "backHistory": "Backup history",
    "setHistory": "Configure history",
    "logManage": "Log",
    "inputurl": "Please enter an IP address with completed URL format to access",
    "upConfirm": "After this operation, the device will disable auto provisioning. Continue?",
    "enableUp": "After this operation, the device will enable auto upgrade. Continue?",
    "closeUp": "After this operation, the device will disable auto provisioning. Continue?",
    "failOp": "Failed to disable auto provisioning. Please disable it manually by logging in to the device Web GUI.",
    "paramSetOk": "Parameter modified successfully",
    "paramSetFail": "Failed to modify parameter: ",
    "setRouteOk": "Routing configuration modified successfully",
    "setRouteFail": "Failed to modify routing table.",
    "backupConfirm": "Make sure you have backed up the current configuration before resetting to factory default. Do you want to continue?",
    "restartConfirm": "It will take a few minutes to reboot, do you want to reboot?",
    "restartOk": "Device rebooted successfully",
    "day": "d ",
    "hour": "h ",
    "min": "m ",
    "sec": "s",
    "getConfFail": "Failed to obtain device configurations",
    "changePwOk": "Password changed successfully",
    "changePwFail": "Failed to change password",
    "changePwFail2": "Failed to change password for incorrect old password or inconsistent new password",
    "sipSer": "SIP server",
    "setDigitOk": "Digit map changed successfully",
    "setDigitFail": "Failed to modify digit map.",
    "more": "Advanced",
    "port": "Line",
    "ipGain": "Gain to IP",
    "PSTNGain": "Gain to PSTN",
    "OutpulDelay": "Outpulsing delay",
    "fxsGain": "Gain to terminal",
    "impedance": "Impedance",
    "impedance_op1": "Complex",
    "impedance_op2": " Ω",
    "param225": "Hook flash timer min",
    "param226": "Hook flash timer max",
    "param220": "Ring frequency",
    "param439": "Caller ID transmission mode",
    "param494_op1": "With parity",
    "param494_op2": "Without parity",
    "param495_op1": "After ringing",
    "param495_op2": "Before ringing",
    "setSipOk": "SIP configurations modified successfully",
    "setSipFail": "Failed to modify SIP configurations. Erroe messages:",
    "inputIpExt": "Please enter IP extension information",
    "regOption": "Registration options",
    "regPort": "SIP listening port",
    "minTimeout": "Min. registration expiration",
    "natMinTimeout": "Min. registration expiration(NAT applied to the IP extension)",
    "safeDomain": "Realm",
    "illegalReg": "Response to INVITE with failed authentication",
    "illegalReg_op1": "Send 403",
    "illegalReg_op2": "Ignore",
    "ipOption": "Sending OPTIONS request to SIP terminal",
    "regOptoin": "Registrar server",
    "line": "Line",
    "regIp": "IP address for IP trusted authentication",
    "regIps":'IP authentication',
    "polderIP":'Please enter the IP address,for example:192.168.1.1',
    "noSend": "Disable",
    "natSend": "To registered IP Ext. behind NAT",
    "allSend": "To any registered IP Ext.",
    "delTrunkOk": "SIP trunk deleted successfully",
    "delTrunkFail": "Failed to delete SIP trunk",
    "addTrunkOk": "SIP trunk added successfully",
    "addTrunkFail": "Failed to add SIP trunk",
    "delIpExtOk": "IP extension deleted successfully",
    "delIpExtFail": "Failed to delete IP extension",
    "addIpExtOk": "IP extension added successfully",
    "addIpExtFail": "Failed to add IP extension, Possibly because: 1)The number is already occupied; 2) Parameter submission errors.",
    "open": "Enable",
    "close": "Disable",
    "inputTrunkInfo": "Please enter trunk information",
    "userDomain": "UA domain name",
    "defaultRegIP": "Default registrar",
    "localPort": "Local signaling port",
    "regTimeOut": "Registration expiration",
    "proxySer": "Proxy service",
    "transLocalPort": "Increments of port number",
    "mulipleReg": "Register to multiple ITSPs",
    "param576": "Obtain caller ID info from",
    "param576_op1": " header",
    "param576_op2": " header",
    "accInfo": "Access network info",
    "inputRoute": "Please enter routing table information",
    "resetOk": "Reset to factory default settings successfully. Do you want to reboot now?",
    "resetFail": "Failed to reset to the factory settings.",
    "inputTar": "Please choose a configuration package",
    "workMode": 'Working mode'
  },
  ISDN: {
    "selectLine": "Select lines",
    "applyOption": "Application",
    "getNumType": "Collecting CDPN",
    "getNumType1": "Overlap",
    "getNumType2": "Enbloc",
    "dChannel": "D channel",
    "interfacePro": "Switch type",
    "channel": "Timeslot",
    "user": "User",
    "network": "Network",
    "singalStandard": "Signaling Standard",
    "selectType": "Circuit hunting",
    "dChannelManage": "D channel service message",
    "pointConn": "Nail-up connection",
    "callNumType": "CPN category",
    "specification": "Standard",
    "noSpecification": "Nonstandard",
    "CPNpresentation": "CPN presentation",
    "CDPNcategory": "CDPN category",
    "otherBusy": "Busy line handling",
    "hangUp": "Hang up",
    "allowChangeLine": "CID exclusive",
    "secDailing": "Second stage dialing",
    "prompt": "Prompt",
    "callNum": "Calling party number (CPN)",
    "originCall": "Originating number",
    "originOther": "Original CDPN",
    "otherCall": "Called party number (CDPN)",
    "otherCall1": "Original CDPN + Second dialed number",
    "otherCall2": "Second dialed number",
    "changeNum": "Digit transformation",
    "ISDN-D": "ISDN-D channel",
    "isdnNote": "Red: channel disabled. Yellow: forbid calls from IP to ISND. Green: channel is clear.",
    "isdnSta": "ISDN-D channel",
    "work": "In service",
    "noWork": "Out of service",
    "ISDN-B": "ISDN-B channel",
    "lock": "Block",
    "unlock": "Unblock",
    "restart": "Restart",
    "forward": "Forward",
    "backward": "Backward",
    "circular": "Circular"
  },
  sip: {
    "server": "Registrar server",
    "domain": "Subdomain name",
    "regType": "Registrar mode",
    "regOp1": "Per line",
    "regOp2": "Per gateway",
    "regOp3": "Per line/GW Auth",
    "username": "User name",
    "password": "Password"
  },
  devSta: {
    "onlineN": "Online devices",
    "offlineN": "Offline devices",
    "totalDev": "Total devices",
    "newDev": "New devices",
    "statistics": "Statistics",
    "statisticsTime": "Time",
    "onlineRate": "Online rate",
    "offlineRate": "Offline rate",
    "total": "Total",
    "statisticsOk": "Succeeded",
    "onlineSta": "Online status",
    "firstOnline": "Online for first time",
    "lastOnline": "Online for last time",
    "lastOffline": "Offline for last time",
    "noReg": "Unregistered",
    "regSuc": "Register success",
    "timeOut": "Timeout",
    "regFail": "Register failure",
    "reging": "INPROGRESS",
    "domainFail": "DNS failure",
    "voltageSta": "Voltage",
    "voltage": "abnormal (too low voltage)",
    "conn": "Connected",
    "disconn": "Unconnected",
    "connSta": "Connection status",
    "lastcall": {
      "0": "No call",
      "1": "In ringing",
      "9": "Out ringback",
      "2": "In normal",
      "10": "Out normal",
      "3": "In failed",
      "11": "Out failed",
      "4": "In timeout",
      "12": "Out timeout"
    },
    "lastcallcode": {
      "1": "Dialing timeout",
      "2": "ACK timeout",
      "301": "Moved Permanently",
      "302": "Moved Temporarily",
      "400": "Bad Request",
      "403": "Forbidden",
      "404": "Not Found",
      "405": "Method Not Allowed",
      "408": "Request Timeout",
      "415": "Unsupported Media Type",
      "423": "Interval Too Brief",
      "480": "Temporarily Unavailable",
      "481": "Call leg/Transaction Does Not",
      "486": "Busy Here",
      "488": "Not Acceptable Here",
      "500": "Server Internal Error",
      "502": "Bad Gateway",
      "503": "Service Unavailable",
      "504": "Server Time-out",
      "603": "Decline"
    },
    "online": "Online",
    "offline": "Offline"
  },
  devUp: {
    "test": "Test",
    "statistics": "Statistics",
    "upgrade": "Upgrade",
    "autoUp": "Auto upgrade",
    "upLog": "History",
    "autoUpLog": "Auto-upgrade history",
    "kernelV": "Kernel version",
    "appV": "App version",
    "upTaskInfo": "Upgrade details",
    "taskName": "Task name",
    "createTime": "Creation time",
    "doTime": "Operation time",
    "result": "Operation result",
    "unknown": "Unknown",
    "failReason": "Failure reason",
    "firmwareV": "Upgrade package version",
    "upDev": "Upgraded devices",
    "sucDev": "Successful devices",
    "failDev": "Failure devices",
    "modTask": "Modify upgrade task",
    "cancelTask": "Cancel the task",
    "description": "Description",
    "baseV": "Requirements for base version",
    "package": "Upgrade package",
    "init": "Install initially",
    "dev": "Device",
    "inputMac": "Please enter device MAC addresses,  separated with commases",
    "addTask": "Create upgrade task",
    "inputDesc": "Please enter description",
    "inputTime": "Please choose the time to upgrade",
    "selectPackage": "Please choose the upgrade package",
    "addUpOk": "Upgrade task created successfully",
    "addValidFail": "Failed to create task. The time to upgrade, description, and upgrade package are necessary",
    "modUpOk": "Upgrade task modified successfully",
    "modValidFail": "Failed to modify task. The time to upgrade, description, and upgrade package are necessary",
    "upInfo": "Upgrade version",
    "inputAutoUp": "Please enter auto upgrade information",
    "selectTime": "Plese choose the time to upgrade",
    "suc": "Upgrade successful",
    "fail": "Upgrade failure",
    "addAutoUpOk": "Auto-upgrade task created successfully",
    "modAutoUpOk": "Auto-upgrade task modified successfully",
    "delAutoUpOk": "Auto-upgrade task deleted successfully",
    "inputTask": " Please select task",
    "inputHistory": "Select record"
  },
  task: {
    "section": "section",
    "menu": "menu",
    "reboot": "Reboot",
    "tarBackup": "Backup configurations",
    "logType": "Type",
    "curLogBackup": "Download log",
    "logBackup": "Download history log",
    "getParamTem": "Backup template parameters",
    "setParamTem": "Config template parameters",
    "getParam": "Backup parameters",
    "setParam": "Configure parameters",
    "setTask": "Assign cloned configurations",
    "importDev": "Import devices",
    "getParam": "Backup parameters",
    "backupConf": "Backup configuration packages in batch",
    "batchBackup": "Backup configurations in batch",
    "batchLogDown": "Download log in batch",
    "modTaskTitle": "Please enter task information",
    "start": "Start",
    "restart": "Restart",
    "stop": "Stop",
    "cancel": "Terminate",
    "loop": "Periodic task",
    "week": "Week",
    "day": "Day",
    "series": "Series",
    "doTime": "Operation time",
    "selectTime": "Please choose the time to upgrade",
    "description": "Description",
    "inputDecs": "Please enter description",
    "taskInfo": "Task details",
    "taskType": "Task type",
    "taskId": "Task ID",
    "taskName": "Task name",
    "monday": "Monday",
    "tuseday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday",
    "monday_d": "Monday",
    "tuseday_d": "Tuesday",
    "wednesday_d": "Wednesday",
    "thursday_d": "Thursday",
    "friday_d": "Friday",
    "saturday_d": "Saturday",
    "sunday_d": "Sunday",
    "everyDay": "Every day",
    "isRestart": "Restart",
    "operator": "Operator",
    "taskStop": "Task is stopped",
    "taskRun": "Task is running",
    "taskCancel": "Task is terminated",
    "progress": "Processing",
    "selectTaskTime": "Please choose the time for task",
    "all": "All tasks",
    "onetime": "Single task",
    "period": "Periodic task",
    "modTaskFail": "Failed to modify the task. The Operation time and Description are necessary",
    "model": "Template",
    "selectModel": "Please select a template",
    "dev": "Device",
    "dev_note": "Please select a device or enter device MAC address manually. Multiple MAC address are separated by commas (e.g. A9039E3412,A90E003455)",
    "inputDev": "Please select device",
    "restartConfirm": "The device will reboot immediately after the task is completed. Do you want to continue?",
    "addTaskOk": "Task created successfully",
    "addTaskFail": "Failed to create task. Operation time, Template, Description and Device are necessary.",
    "addTaskFail2": "Failed to create task. Operation time, Description and Device are necessary.",
    "addTaskFail3": "Failed to create task. Operation time, Description, Device and Parameter are necessary.",
    "addTaskFail4": "Failed to create task. Operation time, Log date, Description and Device are necessary",
    "result": "Operation result",
    "status": "Status",
    "reason": "Reason",
    "needRestart": "Need to restart",
    "noNeedRestart": "No need o restart",
    "lastTime": "Latest operation time",
    "sucDev": "Successful dev.",
    "failDev": "Failure dev.",
    "failMac": "MAC addresses of failed devices",
    "failReason": "Reason",
    "paramID": "Parameter ID",
    "paramVal": "Parameter value",
    "confParam": "Configuration parameter",
    "downTime": "Download time",
    "specParm": "Customized parameter",
    "inputSpecParam": "Please enter customized parameter in the format of '&51=test&99=on'",
    "inputSpecParamId": "Please enter the ID for the customized parameter. Separated by commas for multiple IDs (e.g. 51,57)",
    "taskBefore": "History task",
    "dateUntil": "History tasks after",
    "currentTask": "Current Task",
    "query": "Query",
    "to": " To ",
    "confModel": "Cloned-configuration template",
    "retry": "Retry",
    "retryCue": "You will re-execute the task on the failed device"
  },
  alarm: {
    "setDeployMsg1": 'Do you want to delete call records after {time}?',
    "setDeployMsg2": 'Do you want to delete call records before {time}?',
    "setDeployMsg3": 'Do you want to delete call records from{sTime} to {eTime}?',
    "alog": 'Log',
    "statLog": "Statistics log",
    "linelock": "FXO blocked",
    "device": "Select devices",
    "all": "All devices",
    "groupSet": "Select by group",
    "proTypeSet": "Select by model",
    "userDefined": "Select by list ",
    "serve":"Platform address",
    "devGroup": "Device group",
    "proType": "Model",
    "setAlarm": "Alarm device set successfully",
    "inputAlarm": "Please enter information for alarm event",
    "event": "Event",
    "name": "Name",
    "level": "Level",
    "red": "Red alarm",
    "orange": "Orange alarm",
    "normal": "General alarm",
    "unknow": "Unknown alarm",
    "inputName": "Please enter the alarm name",
    "inputEvent": "Please enter alarm event, e.g. Event=29",
    "selectLevel": "Please select an alarm level",
    "addOk": "Alarm event created successfully",
    "modOk": "Alarm event modified successfully",
    "delOk": "Alarm event deleted successfully",
    "history": "Alarm history",
    "history_event": "Event history",
    "alarmName": "Alarm name",
    "createTime": "Creation time",
    "email": "Email",
    "noSend": "Not sent",
    "weChat": "WeChat",
    "weChat_num": "WeChat ID",
    "phone": "Phone",
    "phoneNum": "Number",
    "confirm": "Confirm",
    "confirmed": "confirmed",
    "selectWechat": "Please select the WeChat ID",
    "selectEmail": "Please select the mailbox",
    "selectPhone": "Please select a phone number",
    "selectDelWechat": "Please select the WeChat ID to delete",
    "selectDelEmail": "Please select the mailbox to delete",
    "selectDelPhone": "Please select the phone number to delete",
    "inputEmail": "Please enter mail server address",
    "emailAddr": "Mailbox",
    "inputPhone": "Please input phone number",
    "dev": "Alarm device",
    "rule": "Alarm rule",
    "period": "Threshold",
    "periodText": "Alarm triggered, in {period} minutes >= {times} events",
    "periodText1": "alarm triggered in",
    "periodText2": "minutes  >=",
    "periodText3": "events",
    "delay": "delay",
    "delayText": "seconds alarm",
    "qrCode": "Scan the QR code",
    "action": "Action",
    "downlog": "Download log",
    "restartapp": "Restart app",
    "ruleNormal": "Ok",
    "ruleAlarm": "Alarm",
    "inform": "Notification",
    "informNote": "Notification (when the alarm you have definded is triggered)",
    "creator": "Creator",
    "log": "History",
    "selectEv": "Please select an event",
    "inputRuleName": "Please enter rule name",
    "inputRuleDesc": "Please enter rule description",
    "addEmailOk": "Mail box created successfully",
    "delEmailOk": "Mail box deleted successfully",
    "delWechatOk": "WeChat deleted successfully",
    "addPhoneOk": "Phone number created successfully",
    "delPhoneOk": "Phone number delated successfully",
    "addRuleOk": "Alarm rule created successfully",
    "modRuleOk": "Alarm rule modified successfully",
    "delRuleOk": "Alarm rule deleted successfully",
    "monitorInfo": "Details of monitor",
    "enable": "Enable monitor",
    "devView": "Device view",
    "batch": "Batch",
    "searchMac": "Enter MAC address to search",
    "enabled": "Monitoring alarms is enabled",
    "closed": "Monitoring alarms is disabled",
    "rebootCue": ", The configuration takes effect after the system is restarted.",
    "batchSetEnable": "Switches set in batch successfully",
    "actionNote": "Action (took when the alarm you definded is triggered)",
    "addAlarmT": "Create alarm",
    "modAlarmT": "Modify alarm",
    "selectedDev": "Selected devices",
    "viewSelected": "Check selected devices",
    "deviceInfo": "Device Information",
    "emptyEmails": "No available emails,please click alarm inform list to add",
    "emptyWechats": "No available wechats,please click inform list to add",
    "emptyPhones": "No available phones,please click alarm inform list to add",
    "notifications": "Inform list",
    "statusDesc": "The status is applicable for alarms generated not earlier that 48 hours ago.",
    "confirmAll": "Are you sure you want to confirm all alarms?",
    "confirmDelEmails": "Once the mailbox is deleted, all created alarms will not inform this mailbox",
    "confirmDelPhones": "Once the phone number is deleted, all created alarms will not inform this phone number",
    "confirmDelWechats": "Once the wechat is deleted, all created alarms will not inform this wechat",
    "monitorG": "Monitor group",
    "monitorTime": "Duration (Day)",
    "queryAll": "View all events",
    "delDevice": "Are you sure you want to remove the device from the monitoring group?",
    "delGroupConfrim": "Are you sure you want to remove this device group from this monitoring group?",
    "monitorGroupTitle": "Monitoring group information",
    "syncTime": "Data synchronization time",//数据同步时间
    "weiweiStat": "Weiwei statistics",//喂喂统计
    "recStat": "RecStat",//
    "sysStat": "System statistics",//
    "rec": "Recording Agent",
    "recLog": "Full log",//
    "avg": "Average call duration",//
    "delete": "Delete time",//
    "ext": "Register extension",//
    "firstregtime": "First registration time of the day",//
    "in": "Inbound connected times",//
    "inmiss": "Number of missed calls",//
    "lastregtime": "Last registration time of the day",//
    "ou": "Number of connected calls",//
    "oumiss": "Number of missed calls ",//
    "pushfail": "Number of push failures",//
    "pushok": "Push success times",//
    "sys": "",
    "total": "Total call duration",//
    "mccs": "Neehau server",//
    "sip_send": "SIP send",//
    "sip_recv": "SIP receive",//
    "callStat": "Call statistics",//
    "rtpStat": "Voice statistics",//
    "appStat": "App statistics",//
    "timeStamp": "TimeStamp",//
    "fxo_disc": "O port is disconnected",//
    "fxo_volt": "O port voltage alarm",//
    "eth_down": "Network down",//
    "web_atmp": "Web login by mistake",//
    "ssh_atmp": "Ssh login error",//
    "dns_err": "DNS error",//
    "queue": "Internal queue is full ",//
    "failover": "Call error transfer to port O",//
    "rec_cnt": "Recording count",//
    "rec_err": "Recording error",//
    "rec_chg": "Recording from remote to local",//
    "ww_cnt": "Weiwei push count",//
    "ww_reg": "Weiwei push receive register in time",//
    "ww_to": "Weiwei push call timed out",//
    "invite": "INVITE message",//
    "inv_dup": "INVITE resend",//
    "cancel": "CANCEL message",//
    "reg": "Register message",//
    "R200": "Register 200 OK",//
    "R401": "Register 401",//
    "R403": "Register 403",//
    "c_200": "Call answer",//
    "c_403": "Call rejection",//
    "c_408": "Call not answered",//
    "c_412": "Call is not online ",//
    "c_480": "Timeout",//
    "c_486": "Busy",//
    "c_5XX": "Other errors",//
    "inc": "inbound",//
    "i_ans": "Incoming call connected ",//
    "i_comp": "Incoming call completed ",//
    "i_fail": "Incoming call not complete",//
    "i_act": "Incoming current",//
    "i_dur": "Incoming timer",//
    "out": "Outbound",//
    "o_ans": "Call connected",//
    "o_comp": "Call complete",//
    "o_fail": "Call error",//
    "o_act": "Call current",//
    "o_dur": "Call time",//
    "ps": "Packet send",//
    "os": "byte send",//
    "pr": "Packet receive",//
    "or": "byte recevice",//
    "pl": "Packet missing",//
    "sl": "Packet sent lost",//
    "intl": "Packet internal lost",//
    "invlid": "Illegal RTP",//
    "dup": "Serial number repeated",//
    "nortp": "Nortp timing received",//
    "inputMonitorName": "Please fill in the monitoring group name",//
    "warn44": "Warning 44",//
    "warn45": "Warning 45",//
    "warn46": "Warning 46",//
    "warn47": "Warning 47",//
    "warn39": "Warning 39",//
    "recv_count": "Number of received recordings",//
    "finish_count": "Number of end recordings",//
    "rec_len": "Total call duration",//
    "record_count": "Number of successful recordings",//
    "rec_loss": "Number of lost recording packages",//
    "max_conn": "The maximum number of concurrent recording sessions in this period",//
    "max_convqueue": "Maximum number of recording conversion queues for this time period",//
    "recv_error": "UDP receiving error",//
    "send_error": "Error encountered during UDP sending",//
    "rtpdata_error": "Recording package size does not match",//
    "conv_error": "Recording synthesis conversion error",//
    "sendEmail_error": "Error message sending mailbox",//
    "movefile_error": "Recording move save error",//
    "uploadLog": "Upload log",//
    "uploadConfirm": "You will upload logs to  ",
    "cloud": "New Rock Cloud",
    "logTime": "LogTime",//
    "Stating": "Start statistics, please check later",//
    "modLevelOk": "Set the log parameters successfully",
    "recParam": "Xerox parameters",//
    "queryOk": "Query successfully!",
    "filter": "Filter",
    "filterOk": "Filtling successful!",
    "is_analized": "Has been analyzed",//
    "originData": "Data",
    "statData": "Charts",
    "recOnlineRate": "Online rate of Recording Agent",
    "recUseRate": "Usage rate of Recording Agent",
    "groupRecOnlineRate": "Online rate of all monitoring groups",//
    "groupUseRate": "Full monitoring group usage",//
    "recParamCue": "Please select full record parameters",//
    "turnonLog": "Enable log moving",//
    "turnonScource": "Enable resource monitoring",//
    "turnonFsp": "Start FSP running ",//
    "preserveRecord": "Locally save recordings upon server disconnected",
    "logStorageCue": "Are you sure you want to change the log move Settings?",//
    "fspCue": "Are you sure you want to change the FSP Settings?",//
    "recordCue": "Are you sure you want to change the Settings for saving disconnected recordings locally?",//
    "setOk": "Set successfully",
    "isStating": "Analizing statistically…",
    "periodic": "Statistical period of device information (s) ",//
    "rec_stat": "Full statistics period (s) ",//
    "rec_hb": "Full heartbeat cycle (s)",//
    "turnoffSourceCue": "Are you sure you want to turnoff the resource monitoring Settings?",//
    "samplingTime": "samplingTime (s)",//
    "runTime": "Run days (days)",//
    "CPUUse": "CPU usage",
    "recordWay": "Recording",
    "record_remote": "Remote recording",
    "record_waizhi": "External USB device",
    "record_neizhi": "Internal USB flash drive",
    "record_sever": "Recording server",
    "inputParam": "Please enter parameter values",//
    "ParamRang": "Parameter value must be 0 or greater than or equal to {minParam}",//
    "statRang": "It should not be less than 0",
    "statFail": "Failed",
    "onlineTime": "Online duration (hour)",
    "recoedNum": "Recording counts",
    "maxcOncurrent": "Max. concurrent calls",
    "averageTime": "Average Call Duration (minute)",
    "startUploadLog": "Begin to upload logs",
    "averageOnlineTime": "Average online duration (h)",//
    "callStatAndNeizhi": "Call and recording statistics",//
    "downDate": "download Date",//
    "addSingleDevCue": "You will add this device to:",//
    "inputAppName": "Please enter the full record name",//
    "inputRec": "Please select full record",//
    "inputRecLabel": "Application",//
    "modAppCue": "Modify full record application",//
    "recTypeSummary": "There are {innerCount} platforms for built-in storage, {remoteCount}  platforms for remote recording, and {unknownCount}  platforms for unknown storage",//
    "noDevice": "No device",//
    "isUploadingLog": "Uploading log",//
    "noexsitingInUms": "The device is not in esight, please add it to the device list ",//
    "weiweiDetail": "Weiwei details ",//
    "innerRec": "InnerRec",//
    "neehaoStat": "Nhaostat",//
    "weiweiMonitor": "Data report",//
    "turnOnWeiweiMonitor": "You will enable the data reporting function of this device",//
    "turnOffWeiweiMonitor": "You are going to turn off the data reporting function for this device ",//
    //新增
    "fileUpload": "Voice",
    "description": "Description",
    "voice": "Voice",
    "selectDelVoice": "Please select the voice to delete",
    "delVoiceOk": "Voice deleted successfully",
    "selectVoice": "Please select the voice",
    "emptyVoice": "No available voices,please click alarm inform list to add",
    "playVoice": "Play",
    "shout": "Call monitoring",
    "hostMachine": "HostMachine",
    "slaveapplication": "Slaveapplication",
    "hostInput": "HostInput",
    "slaveInput": "SlaveInput",
    "addHostMachine": "AddHostMachine",
    "startTime": "StartTime",
    "endTime": "EndTime",
    "until": "Until",
    "deleteAll": "Whether to delete all call monitoring records?",
    "if": "if",
    "complateDate": "The selected interval should be within three months"
  },
  event: {
    "eventArray0": "No alarm",
    "eventArray1": "Device re-start",
    "eventArray2": "DS1 down",
    "eventArray3": "DS1 up",
    "eventArray4": "ISDN down",
    "eventArray5": "ISDN up",
    "eventArray6": "ENDPOINT CHANGE",
    "eventArray7": "APP exit",
    "eventArray8": "EMS hold",
    "eventArray9": "EMS unhold",
    "eventArray10": "Registrar fail",
    "eventArray10_MX_1": "FXS registration failed",
    "eventArray10_MX_2": "FXO registration failed",
    "eventArray11": "Registrar ok",
    "eventArray11_MX_1": "FXS registration succeeded",
    "eventArray11_MX_2": "FXO registration succeeded",
    "eventArray12": "APP restart",
    "eventArray13": "ETH link up",
    "eventArray14": "Password modification",
    "eventArray15": "Login ok",
    "eventArray16": "Login failure",
    "eventArray17": "Error registration",
    "eventArray18": "DNS error",
    "eventArray19": "Change ip",
    "eventArray20": "Configuration change",
    "eventArray21": "ETH link down",
    "eventArray22": "FXO disconnection",
    "eventArray23": "FXO connection",
    "eventArray24": "Queue of internale messages overloaded",
    "eventArray25": "INVITE timeout",
    "eventArray26": "SSH login",
    "eventArray27": "IP attack",
    "eventArray28": "Reset factory settings",
    "eventArray29_1": "Analog trunk ",
    "eventArray29_2": " abnormal (too low voltage)",
    "eventArray30": " Hunt group is unreachable",
    "eventArray31": "Primary SIP server switched to be secondary server",
    "eventArray32": " The available RTP port range is too narrow",
    "eventArray33": " is empty",
    "eventArray33_1": "",
    "eventArray34": " does not exist on this device",
    "eventArray35": "IP extension is offline",
    "eventArray36": "IP extension is online",
    "eventArray37": "IP extension is deregistered",
    "eventArray38": "IP extension registeration duplicated",
    "eventArray39": "WeWei extension is offline",
    "eventArray40": "WeWei extension is online",
    "eventArray41": "WeWei extension is deregistered",
    "eventArray42": "Calls on recording exceeds limitation",
    "eventArray43": "Remote server recording failed and switched to local recording",
    "eventArray44": "Recording server is out of range",
    "eventArray45": "Recording server out of range restored",
    "eventArray46": "Recording server congestion",
    "eventArray47": "Recording server congestion restored",
    "eventArray48": "RTP warning",
    "eventArray48_1": "RTP warning (one-way audio)",
    "eventArray48_2": "RTP warning (too much packages dropped)",
    "eventArray_DID": "The DID number for the trunk number ",
    "loginArray0": "Operator login",
    "loginArray1": "Administrator login",
    "changePw0": "Change password for operators",
    "changePw1": "Change password for administrators",
    "changePw2": "SSH root password changed",
    "changePw3": "SSH operator password changed",
    "loginAttemptArray0": "Attempt login",
    "loginAttemptArray1": "From NAT remote,not allowed",
    "loginAttemptArray2": "Failed Web login attempt",
    "loginAttemptArray3": "Brute force login",
    "loginAttemptArray4": "Password not given",
    "event_part1": "Received",
    "event_part2": "error registrar requests",
    "event_dns": "DNS error",
    "callTimeout1": "Timeout on calling ",
    "callTimeout2": "",
    "dosAttack": "DoS attack",
    "sshfail": "Invalid SSH login password",
    "wrong": "Error "
  },
  callStatus: {
    lineId: 'LineID',
    number: 'Number',
    "calling": "In conversation",
    "free": "Idle",
    "settingUp": "In-progress",
    "other": "Other",
    "lineName": "Line ID",
    "regSta": "Register status",
    "lineSta": "Line status",
    "curCall": "Current call",
    "otherNum": "Phone No. (Other End)",
    "callTime": "Duration",
    "lastCall": "Last call",
    "errorcode": {
      "1": "Dialing timeout",
      "2": "ACK timeout",
      "301": "Moved Permanently",
      "302": "Moved Temporarily",
      "400": "Bad Request",
      "403": "Forbidden",
      "404": "Not Found",
      "405": "Method Not Allowed",
      "408": "Request Timeout",
      "415": "Unsupported Media Type",
      "423": "Interval Too Brief",
      "480": "Temporarily Unavailable",
      "481": "Call leg/Transaction Does Not",
      "486": "Busy Here",
      "488": "Not Acceptable Here",
      "500": "Server Internal Error",
      "502": "Bad Gateway",
      "503": "Service Unavailable",
      "504": "Server Time-out",
      "603": "Decline"
    },
    "sta": {
      "regStatus0": "Unregistered",
      "regStatus1": "Register success",
      "regStatus2": "Register failure",
      "regStatus3": "Server not response",
      "regStatus4": "Timeout",
      "lineStatus0": "Idle",
      "lineStatus1": "Off-hook",
      "lineStatus2": "Ringing",
      "lineStatus3": "Maintenance",
      "lineStatus4": "Disconnected",
      "lineStatus5": "Parellel line in use",
      "callStatus0": "Idle",
      "callStatus1": "",
      "callStatus2": "Outpulsing ",
      "callStatus3": "Ringing",
      "callStatus4": "Entering Numer ",
      "callStatus5": "In Progress ",
      "callStatus6": "Ring Back",
      "callStatus8": "Talk",
      "callStatus9": "Near-end Hung Up",
      "callStatus10": "Timeout",
      "callStatus11": "Phone No. (Other End)",
      "callStatus12": "Unknow",
      "c": "Caller",
      "d": "Callee",
      "lastcall_1": "No call",
      "lastcall_2": "In ringing",
      "lastcall_3": "Out ringback",
      "lastcall_4": "In normal",
      "lastcall_5": "Out normal",
      "lastcall_6": "In failed",
      "lastcall_7": "Out failed",
      "lastcall_8": "In timeout",
      "lastcall_9": "Out timeout"
    },
    "getStaFail": "Failed to obtain data status"
  },
  ISDNSTA: {
    "ID": "ID",
    "callSta": "Call status",
    "CallDirection": "Direction",
    "callNumber": "Phone No.(This End)",
    "otherNumber": "Phone No.(Other End)",
    "param1": "Operation",
    "param2": "is not in use",
    "param3": "Idle",
    "param4": "Init",
    "param5": "Outgoing Proceeding",
    "param6": "Delivered",
    "param7": "Present",
    "param8": "Incoming Proceeding",
    "param9": "Received",
    "param10": "Connect Request",
    "param11": "Active",
    "param12": "Disconnect Indicator",
    "param13": "Disconnect Request",
    "param14": "Release Request",
    "param15": "Overlaping Receiving"
  },
  tdm: {
    "ds1": "DS1 type",
    "pcm": "PCM codec",
    "sync": "Timing source",
    "frame": "Framing",
    "line": "Line code",
    "cable": "Line length",
    "cableImpedance": "Line impedance",
    "local": "Local",
    "m": "m",
    "long": "Long haul",
    "short": "Short haul",
    "confOk": "Device set successfully",
    "confFail": "Failed to set the device"
  },
  telnet_ssh: {
    "stopTimeTitle": "Please select the expiration date",
    "stopTime": "Expiration date",
    "access": "Role for access",
    "confirmPw": "Confirm password",
    "createSSH": "Create SSH access proxy",
    "cancelSSH": "Cancel SSH access proxy",
    "createTelnet": "Create Telnet access proxy",
    "cancelTelnet": "Cancel Telnet access proxy",
    "proxyIP_ssh": "Proxy address for SSH access",
    "proxyDeadLine_ssh": "SSH proxy expiration date",
    "proxyIP_tel": "Proxy address for Telnet access",
    "proxyDeadLine_tel": "Telnet proxy expiration date",
    "selectDeadLine": "Please select an expiration date",
    "createOk": "Proxy service created successfully",
    "delOk": "Proxy service deleted successfully",
    "confirm": "Another client has already login the device. Do you want to force it logout and continue to modify the configurations?",
    "confFail": "Failed to modify configurations.",
    "confOk": "The configurations take affect after the device reboots",
    "telnetPort": "Telnet port",
    "sshPort": "SSH port",
    "changeVcode": "Change",
  },
  user: {
    "select": "Select",
    "account": "Account",
    "pw": "Password",
    "confirmPw": "Confirm password",
    "userName": "User name",
    "phone": "Mobile phone",
    "contacts": "Contact",
    "token":'Token',
     "token1":'Token:',
    "generate":'Generate token',
    "lock": "Locked",
    "groupReq": "The device group is necessary",
    "pwReq": "Password is necessary",
    "inputError": "The content you entered did not meet the requirement",
    "unallow": "It will forbid this user to access the system. Do you want to continue?",
    "allow": "It will allow this user to access the system. Do you want to continue?",
    "addUser": "Please enter user information",
    "inputAcc": "Please enter the account",
    "inputAcc1": "The account is a string with the length of 5 to 16 characters. It should start with an English letter and can contain numbers, letters and underline '_'.",
    "accRule": "In the length of 3 to 15 characters",
    "inputUsername": "Please enter the user name",
    "addUserOk": "User added successfully",
    "modUserOk": "User modified successfully",
    "delUserOk": "User deleted successfully",
    "safe": "Security settings",
    "user_level": "User Type",
    "domainAdmin": "Admin",
    "userAdmin": "User",
    "sysadmin": "System admin",
    "selectDomain": "Please select a domain",
    "opFail": "Account already exists, please change it.",
    "groupTip": 'Device group selection cannot be cross-domain',
     "tokenOk":'Succeeded in generating token',
     "tokenverok":"The authentication mode is changed successfully. Procedure",
     "tokentip":"Token binding"
  },
  role: {
    "select": "Select",
    "label": "Role",
    "selectRole": "Please select a role",
    "addRoleS": "Role added successfully",
    "modRoleS": "Role modified successfully",
    "delRoleS": "Role deleted successfully",
    "addRole": "Please enter role information",
    "selectUserLevel": "Please select user type",
    "name": "Alias name",
    "pri": "Permission",
    "roleID": "Name",
    "roleAlarm": "Role already exists, please change it.",
    "roleRequire": "The role name is required"
  },
  cloudID: {
    "inputId": "Input your Cloud information",
    "title": "Attention: Remember to add the IP address of UMS into the cloud trusted IP address list, else the device is unreachable.",
    "account": "Cloud Account",
    "domain": "Domain",
    "token": "Token",
    "nickName": "Alias",
    "update": "Time for sync",
    "tokenUpdate": "Device sync",
    "inputCloud": "Please enter the cloud account",
    "number": "It must be a number",
    "inputToken": "Plesase enter a token",
    "devInpro": ",{count} devices have been scanned",
    "unsynchronized": "Unsynchronized",
    "regRefresh": "Synchronize per day",
    "manualRef": "Sync manually"
  },
  dataBackup: {
    "uploadCue": "Please upload backup file",
    "backupTar": "Backup package",
    "backup": "Backup",
    "recover": "Recover",
    "content": "Storage space",
    "spaceUse": "Occupied space",
    "clear": "Clear",
    "param": "Device parameters",
    "log": "Operation log",
    "task": "Delete",
    "devUp": "Device upgrade",
    "devSta": "Device status",
    "devLog": "Device log",
    "devBackup": "Backup configuration",
    "firmware": "Upgrade package",
    "recoverOk": "Recovered configurations succefully",
    "confirm": "It will clear the data permanently. Do you want to continue?",
    // "clearOk": "Data cleared successfully",
    "callstate": 'Call status',
    "clearOk": "It takes approximately{cleanTime}minutes to clean up the data",
    "date": "Date",
    "week": "A week ago",
    "oneM": "A month ago",
    "threeM": "Three months ago",
    "sixM": "Six months ago",
    "year": "A year ago",
    "selectDate": "Please select a date",
    "confirmThreeM": "Confirm to clear up the data of three months ago",
    "cleanCue": "Clear up history record",
    "dateBefore": "Delete the data before date",
    "dateAfter": "",
    "metricHistory": "Event history",
    "alarmHistory": "Alarm history",
    "confirmBackUp": "Are you sure you want to back up data?",
    "storageAll": "Total",
    "diskStorage": "Capacity(Total{storageAll}GB",
    "disk_free": "Free space",
    "disk_used": "Used space",
    "clean_db_config": "Automatic cleaning",
    "clean_db_config_info": "Automatically clearing database configurations",
    "clean_db_config_label2": 'Storage duration of device logs',
    "clean_db_config_label3": 'Storage duration of event history',
    "clean_db_config_label4": 'Automatically clearing time',
    "clean_db_config_ok": 'Configuration succeeded',
    "clean_db_tip_info": '0 indicates that this function is disabled',
    "clean_valid_info": 'Please input number',
    "backupconfig": 'Auto backup',
    backConfigInfo: 'Auto backup',
    perMonth: 'Per',
    geri: 'Current month',
  },
  domain: {
    "addDomain": "Please enter domain information",
    "domainName": "Domain",
    "id": "ID",
    "inputDomain": "Please enter the domain name",
    "addDomainS": "Domain added successfully",
    "modDomainS": "Domain modified successfully",
    "delDomainS": "Domain deleted successfully"
  },
  firmware: {
    "baseVersion": "Please enter base version information",
    "firmwareTitle": "Please enter upgrade package information",
    "componentTitle": "please enter component information",
    "baseApp": "App base version",
    "baseKernel": "Kernel base version",
    "baseOther": "Other base versions",
    "baseOtherNote": "Enter in the format like 'autoupd:3.0.145;boa:2.0.48'",
     "kernelVersion": "kernel version",
    "kernelVersionMaxLength": "The maximum length of the kernel version is {length} characters",
    "test": "Test version",
    "firmware": "Upgrade package",
    "proType": "Product model",
    "version": "Version",
    "lang": "Language",
    "ch": "Chinese",
    "en": "English",
    "multiLang": "Multilingual",
    "release": "Release notes",
    "component": "Component",
    "release2": "Release notes:",
    "baseApp2": "App base version",
    "baseKernel2": "Kernal base version",
    "baseOther2": "Other base versions",
    "fileSize": "File size",
    "uploadTime": "Time for upload",
    "baseVersionRule": "Requirements for base version",
    "inputRelease": "Please enter release information",
    "inputApp": "Please enter app version number",
    "selectFirmware": "Please choose upgrade package",
    "delOk": "Deleted successfully",
    "modOk": "Modified successfully",
    "addOk": "Added successfully",
    "uploadRule": "The file to upload must be named with the beginning 'cloud_basic'",
    "cloudPackage": "Upgrade package for cloud platform",
    "cloudVersion": "Version information ",
    "force_upgrade": "Force to upgrad",
    "rlsTitle": "Title",
    "series": "Series",
    "aws": "Stored to aws",
    "yes": "Yes",
    "no": "No",
    "inputRlsT": "Please enter upgrade package name",
    "inputVer": "Please enter  information upgrade package version",
    "selectSeries": "Please choose the series of upgrade package",
    "selectProduct": "Please choose the model of the upgrade package",
    "isTestVer": "Test  version?",
    "type": "Type",
    "jkType": 'monitorType',
    "isForceUpgrade": "Is it a forced upgrade ",
    "ipphonePlaceholder": 'Enter the version number that is consistent with the upgrade package'
  },
  sysInfo: {
    "import": "Import License",
    "license": "Please import License file",
    "info": "License information",
    "reqKey": "Application code of certificate:",
    "deviceLimit": "Limit of managed devices:",
    "stopTime": "Expiration date:",
    "server": "Server information",
    "domain": "Domain name:",
    "localIP": "Local IP address:",
    "version": "System version",
    "update": "Check for updates",
    "curVersion": "Current version:",
    "newVersion": "New version:",
    "upgrade": "Upgrade",
    "getVerF": "Failed to obtain version information",
    "upLicenseOk": "License  uploaded successfully, it will take affect after the system reboots",
    "modSerInfoOk": "Server information modified successfully！If the port is changed, you have to reboot the UMS server to validate the login with the new port.Do you want to reboot now?",
    "newVersionRel": "Version Info: ",
    "restartOk": "Please log in again",
    "restartFail": "Restart failed",
    "restarting": "The system is restarting, please wait",
    "serverPort": "Port:",
    "confirmRestart": "Are you sure you want to restart the UMS?",
    "pushInfo": 'Push config', //新增
    "pushAlarm": 'Push alarm:',//新增
    "pushDevice": 'Push device status:',//新增
    "pushUrl": 'Push url:',//新增
    "urlInfoTip": 'Format:protocol://Domain Name:port/custom directory, the protocol is HTTP or HTTPS, the domain name can also be set as IP address, and the custom directory can be set as multi-layer directory, such as /push/test',//新增
    "success": 'Submit successfully',//新增
    "pushOn": 'ON',
    "pushOff": 'OFF',
    "MsgTip": 'Please enter push url',
    "noConfig": 'Not configured',
    "pushAlarmType": 'Alarm push type:',
    "alarmCycleTitle": 'Statistical cycle configuration',
    "alarmCycle": 'Alarm statistics cycle:',
    "callCycle": 'Call count cycle:',
    "recently": 'recently',
    "hour": 'hour',
    "day": 'day',
    "month": 'month',
    "min": 'min.',
    "initLang": 'The default login language',
    "langConfig": "Language config:",
    "pri": 'Notifications turned on:',
    "email": 'Email',
    "weixin": 'Wechat',
    "phone": 'Phone',
    "logUms": 'ums:',
    "logUmsdevice": 'umsdevice:',
    "logUmswatch": 'umswatch:',
    'logType': 'Type:',
    'logretry': 'Login retry lockout', //身份鉴别
    'maxFailCount': 'Max. login failure:',
    'lockDuration': 'Lock time:',
    'lockRange': '(Range: 0 - 59)',
    'webdisable': 'Disable',
  },
  log: {
    "selectLogType": "Please choose log type",
    "originIp": "Source IP address",
    "login": "Login",
    "loginout": "Logout",
    "token": "Token",
    "group": "Group",
    "device": "Device",
    "firmware": "Upgrade package",
    "domain": "Domain",
    "user": "User",
    "privilege": "Privilege",
    "err":'Unauthorized: The certificate is invalid or expired',
  },
  template: {
    "param": "Parameter template",
    "name": "Template name",
    "file": "Clone configurations",
    "desc": "Remark",
    "fileName": "File name",
    "inputParamVal": "Please enter parameter value",
    "mod": "Modify template",
    "info": "Template details",
    "paramType": "Parameter type",
    "paramOption": "parameter options",
    "createTime": "Creation time",
    "createOp": "Creator",
    "inputName": "Please enter tmplate name",
    "opFail": "Failed. The template already exists",
    "validFail": "The information you added is invalid, please try again",
    "addTemFail": "Template name already exists, please change it.",
    "configFile": "Configuration file",
    "selectDev": "Select a device whose configurations to be cloned",
    "getFile": "Please choose file"
  },
  param: {
    "mult_select": "Checkbox",
    "uploadExcel": "Please upload parameter excel file",
    "inputContent": "Please enter parameter information",
    "inputType": "View type",
    "valList": "Value list",
    "default": "Default value",
    "inputParamID": "Please enter parameter ID",
    "inputName": "Please enter parameter name",
    "inputChName": "Please enter Chinese parameter name",
    "inputEnName": "Please enter English parameter name",
    "select": "Drop-down list",
    "input": "Text field",
    "radio": "Radio button",
    "readOnly": "Read-only parameter",
    "repeat": "Failed. The parameter already exists",
    "info": "Details",
    "section": "section",
  },
  // 新增
  setDeploy: {
    "stotal": "Total",
    "sRerty": 'Rerty',
    "complete": 'Complete',
    "configContent": 'Configure the content',
    "configNull": 'Configuration is empty',
    "notRunning": "Not running",
    "runningTotal": "Running/Total",
    "running": "Running",
    "notStarted": "Not started",
    "success": "Success",
    "failed": "Failed",
    "doneTotal": "Done/Total",
    "configFilename": "Config filename",
    "stop": "stop",
    "start": "start",
    "cancel": "cancel",
    "startTask": "Are you sure you want to start the task?",
    "stopTask": "Are you sure you want to stop the task?",
    "cancelTask": "Are you sure you want to cancel the task?",
    "selectGroup": "Select group",
    "add1": "Create manual deploy task",
    "add2": "Create auto deploy task",
    "concurrentTasks": "Concurrent tasks",
    "remark": "Remark",
    "select": "select date",
    "please": "Select",
    "yes": "Yes",
    "no": "No",
    "timeTask": "Time task",
    "manualTime": "Manual time",
    "addType": "Select devices",
    "addType1": "Select by group",
    "addType2": "Select by list",
    "tab1": "Tasks",
    "tab2": "Manual Deploy",
    "tab3": "Auto Deploy",
    "taskName": "Task name",
    "downConfig": "Deploy config",
    "versionUpdate": "Upgrade",
    "phoneAssign": "Assign number",
    "taskTime": "Time",
    "tableTime": "Start",
    "deviceType": "Model",
    "config": "Config files",
    "updatePackage": "Firmware",
    "assignPhone": "Assign number",
    "createTime": "Creation time",
    "taskProgress": "Status",
    "oper": "Operations",
    "create": "Create",
    "group": "Group",
    "setDeployMsg1": 'Please select at least one task in configuration, upgrade package, and number assignment',
    "selectDeviceGroup": 'Select at least one device group',
    "selectDeviceOne": 'Select at least one device',
    "deviceNum100": 'You cannot select more than 100 devices',
  },
  ipphoneConfig: {
    "add": "Add config file",
    "name": "Config filename",
    "pType": "Model",
    "IpphonepType": 'IPPHONE model',
    "templateName": "Template name",
    "remark": "Description",
    "userId": "Created by",
    "time": "Creation time",
    "file": "Config files",
    "fileSize": "File size",
    "modify": "Edit",
    "required": "required",
    "selectUseLine": "Select a line for the configuration to take effect:",
    "sysLog": 'System log',
    "telphoneSet": 'Phone Settings',
    "line": 'Line',
    "voiceCode": 'Voice coding'
  },
  api_app: {
    "api": "API setting",
    "whiteList": "whiteList",
    "addWhiteList": "Create whiteList",
    "inputUrl": "Please input IP,for example:192.168.1.1 or 192.168.1.0/24",
    "inputRemark": "Please input description",
    "tableHeader": 'IP',
    "logType1": 'ums',
    "logType2": 'umsdevice',
    "logType3": 'umswatch',
    "logType4": 'umsmaintenance',
    "logType5": 'mongod',
    "logType6": 'mqtt',
    "logType7":'others'
  },
  license: {
    license: "UC证书",
    licensebtn: "证书制作",
    creator: "制作人",
    orderno: "订单号",
    cicType: "证书类型",
    uc: "UC全功能版",
    zx: "直销版",
    bz: "标准版",
    ai: "AI版",
    createTitle: "请填写证书信息",
    inputOrderno: "请输入订单号",
    inputCic: "请选择证书类型",
    time: "制作时间",
    success: "制作成功",
    downLicense: "下载证书",
    inputMac: "请输入正确的设备MAC"
  },
  licenseOm8000: {
    standby: "主备",
    liuliang: "流量均衡许可数",
    licenseName: "设备证书",
    y: "年",
    m: "月",
    menuName: "设备证书",
    license: "证书制作",
    formbrand: "品牌",
    formproduct: "产品",
    form1: " 订单号",
    form2: "客户姓名",
    form3: "联系电话",
    form4: "客户公司名",
    form5: "备注",
    form31: "授权信息",
    form311: "分机授权",
    form3111: "设备MAC",
    form3112: "分机授权",
    form3113: "API授权",
    form3114: "PMS授权",
    form31121: "分机数",
    form31122: "手工输入",
    form3115: "有效期",
    form3116: "激活",
    form3117: "永久",
    form3118: "是否激活",
    form32: "HA证书",
    form321: "1#设备MAC",
    form322: "2#设备MAC",
    form323: "原功能证书设备MAC",
    rule1: "必填",
    rule2: "必须是整数",
    rule3: "至少激活一个授权信息或者HA证书",
    rule4: "HA证书至少输入一个mac地址",
    rule5: "请输入正确的号码",
    rule6: "请输入有效期",
    rule7: "1#设备mac和2#设备mac不能相同",
    search: "搜索",
    search1: "订单号",
    search2: "MAC",
    search3: "客户公司名",
    search4: "产品名",
    table1: "客户公司名",
    table2: "证书类型",
    machineCode: '机器码',
    cdrauthorization: 'CDR授权',
    lbauthorization: 'LB授权',
    oneMon: "一个月",
    threeMon: "三个月",
    halfYear: "半年",
    oneYear: "一年",
    secondYear: "两年",
    threeYear: "三年",
    tenYear: "十年",
    formOneMachine: '1号机MAC',
    formTwoMachine: '2号机MAC',
    haTips: "一套OM8000",
    standlyTips: '两套OM8000设备间互为主备',
    remotedisa: '异地容灾',
    limitTerminal: "可管理终端数",
    callAuth: "呼叫并发授权",
    meetAuth: "会议并发授权",
    voiceAuth: "语音信箱授权",
    extrecordAuth: "分机录音授权",
    centrexAuth: "Centrex授权",
    newlyncAuth: "Newlync接口授权",
    cloudAuth: "第三方Cloud接口授权",
    aiinterAuth: "AI接口授权",
    bookAuth: "通讯录管理授权",
    broadcastAuth: "广播/对讲授权",
    outrecordAuth: "外置录音接口授权",
    mastercluster: "主控集群容灾授权",
    mediaResource: "媒体资源集群容灾授权",
    dbcluster: "数据库集群容灾授权",
    concurrentAuth: "并发授权",
    terminalnumAuth: "终端授权",
    oneCode: '1号机机器码',
    twoCode: '2号机机器码',
    oldCode: '原功能证书设备机器码',
    mediaLabel: '媒体资源许可数',
    dbLabel: '数据库许可数',
    callLabel: '呼叫并发许可数',
    meetLabel: '会议并发许可数',
    voiceLabel: '语音信箱许可数',
    extrecordLabel: '分机录音许可数',
    dsAuth: 'DS1授权',
    dsLabel: 'DS1许可数'


  },
  licenseUms: {
    menuName: "网管证书",
    inputTel: '请输入正确的联系电话',
    applyCode: '申请码',
    fun: '功能',
  },
  licenseNewlyncAS: {
    menuName: "Newlync应用服务证书",
  },
  licenseNewlync: {
    menuName: "NewLync证书",
    name:"客户姓名",
    phone:"手机",
    firename:"企业名称",
    address:"公司地址",
    remark:"备注",
    ldap:"通讯录功能",
    max_contacts:"最大人数",
    enableorN:"是否启用",
    activate:"启用",
    recording:"录音功能",
    max_record_conn:"录音最大并发数",
    cdr:"CDR计费功能",
    req_key:"授权请求key",
    expired:"有效期截止日志",
    features:"授权功能",
    visbel:"企业版本",
    cdr_fee:"CDR计费功能"
  },
  licenseRP: {
    menuName: "RMS 全录 PMSAPI",
  },
  licenseExpire: {
    menuName: "穿透开通记录",
    phobne:"客户手机",
    company:"公司",
    address:"地址",
    type:"类型",
    expired:"有效期至",
    request_code:"申请码",
    typetile:"产品类型",
    expired1:"过期时间",
    email:"邮箱地址",
    release:"全录",
    nameTip:"请输入客户名称",
    expiredTip:"请选择日期",
    condition:"穿透开通状态",
    Active:"是否服务中",
    waringTip:"未开通或已过期",
    service:"服务中",
    notservice:"未服务"
  },
  licensethrough: {
    menuName: "即将过期证书",
    expiringdays:"即将过期天数",
    type:"类型",
    client:"客户",
    company:"公司名",
    expired:"过期时间",
    notify_count:"发送通知次数",
    agin:"重发预警邮件",
    send:"发送",
    renew:"续费",
    renewTip:"已续费",
  },
  licenseTLS:{
    menuName:"设备TLS证书"
  },
  neehau: {
    "reportError": "Neehau issues",
    "neehauStat": "Neehua statistic",
    "appStat": "Recording statistic"
  },
  numberSource: {
    "number": "Number",
    "mac": "MAC",
    "assignAt": "Assigning time",
    "assignStatus": "Assigning status"
  },
  phoneSource: {
    "phone": "Number",
    "mac": "Mac",
    "password": "Password",
    "downTemplate": "Download template",
    "confirmChangeStatue": "Are you sure you want to change the auto-assignment status?",
    "cancelChange": "Change cancelled",
    "macError": "Malformed mac address",

  },
  // 新增结束
  devInsp: {
    "devInspection": "Device diagnosis",
    "serviceInfo": "Service Information",
    "createHttps": "Create Https",
    "createTelent": "Create Telnet",
    "createSSH": "Create SSH",
    "cmd": "Command",
    "p2pTest": "P2P test",
    "p2pResult": "P2P client",
    "downLog": "Download device log",
    "run": "run",
    "param": "parameter",
    "createS": "Create service successfully",
    "deleteS": "Delete service successfully",
    "logList": "Log list",
    "refreshLog": "Refresh",
    "reloadOk": "Refresh successfully",
    "start": "Start packet capture",
    "stop": "Stop packet capture",
    "statusCheck": "Online status check",
    "goto": "Go to",
    "downusbLog": "Download USB Logs"
  },
  CodeData: {
    0: ["200", "Succeeded", ""],
    1: ["200", "Failed", ""],
    10000: ["400", "Login failed", "wrong password or wrong account"],
    10001: ["403", "Not logged in", "login timeout"],
    10002: ["403", "Unauthorized", "wrong certification or certificate expired"],
    10003: ["403", "Login failed", "user has been locked because of too many times of wrong password"],
    10004: ["403", "Login failed", "need to add the current IP address to the security group."],
    10005: ["403", "No permission", "not Allowed"],
    10006: ["403", "Login failed", "user has been locked"],
    10010: ["400", "Failed to create a new user", ""],
    10011: ["400", "Failed to create a new user", "missing parameter"],
    10012: ["400", "Failed to create a new user", "no permission"],
    10013: ["400", "Failed to create a new user", "need correct role"],
    10014: ["400", "Failed to create a new user", "user has existed"],
    10015: ["400", "Failed to create a new user", "the role type cannot be super admin"],
    10016: ["400", "Failed to create a new user", "domain does not exit"],
    10017: ["400", "Failed to create a new user", "wrong phone number"],
    10020: ["400", "Failed to modify the user", "user does not exit"],
    10021: ["400", "Failed to modify the user", ""],
    10022: ["400", "Failed to modify the user", "no permission"],
    10023: ["400", "Failed to modify the user", "failed to set the role type"],
    10024: ["400", "Failed to authenticat", "wrong password"],
    10025: ["400", "Failed to modify the user", "wrong phone number"],
    10026: ["400", "Failed to modify the user", "wrong E-mail format"],
    10030: ["400", "Failed to get the user", "user does not is exit"],
    10031: ["400", "Failed to get the user", "no permission"],
    10040: ["400", "Failed to delete the user", ""],
    10041: ["400", "Failed to delete the user", "no permission because of default user"],
    10042: ["400", "Failed to delete user", "no permission"],
    10050: ["400", "Failed to delete role", ""],
    10051: ["400", "Failed to delete role", "role does not exit"],
    10052: ["400", "Failed to delete role", "no permission because of default role"],
    10053: ["400", "Failed to delete role", "no permission"],
    10054: ["400", "Failed to delete role", "in use"],
    10060: ["400", "Failed to modify the role", "role does not exit"],
    10061: ["400", "Failed to modify the role", ""],
    10062: ["400", "Failed to modify the role", "no permission because of default role"],
    10063: ["400", "Failed to modify the role", "no permission"],
    10064: ["400", "Failed to modify the role", "wrong parameter of privilege"],
    10070: ["400", "Failed to create a new role", ""],
    10071: ["400", "Failed to create a new role", "missing parameter"],
    10072: ["400", "Failed to create a new role", "no permission"],
    10073: ["400", "Failed to create a new role", "role has exited"],
    10074: ["400", "Failed to create a new role", "wrong parameter of privilege"],
    10075: ["400", "Failed to create a new role", "wrong parameter"],
    10076: ["400", "Failed to create a new role", "wrong role name"],
    10080: ["400", "Failed to obtain role", "role does not exit"],
    10081: ["400", "Failed to list roles", ""],
    10082: ["400", "Failed to list roles", "no permission"],
    10091: ["400", "Failed to add cloud account", "no permission"],
    10092: ["400", "Failed to modify cloud account", "no permission"],
    10093: ["400", "Failed to delete cloud account", "no permission"],
    10094: ["400", "Failed to delete cloud account", "cloud account does not exit"],
    10110: ["400", "Failed to obtain configurations", "configure the token of auto discovery first"],
    10111: ["400", "Failed to configure the token for discovery", "missing parameter"],
    10112: ["400", "Failed to configure the token for discovery", ""],
    10113: ["400", "Failed to delete the token for discovery", "no userid"],
    10114: ["400", "Failed to delete the token for discovery", ""],
    10115: ["400", "Failed to modify the token for discovery", "userid does not exit"],
    10116: ["400", "Failed to modify the token for discovery", "no userid"],
    10117: ["400", "Failed to configure the token for discovery", "userid has exited"],
    10118: ["400", "Failed to configure the token for discovery", "token does not exit"],
    10119: ["400", "Failed to configure the token for discovery", "wrong token or wrong user name"],
    10120: ["400", "Failed to create a new domain", "no permission"],
    10121: ["400", "Failed to create a new domain", "missing parameter"],
    10122: ["400", "Failed to create a new domain", ""],
    10123: ["400", "Failed to create a new domain", "domain name has exists"],
    10124: ["400", "Failed to create a new domain", "default domain has exits"],
    10130: ["400", "Failed to modify the domain", "no permission"],
    10131: ["400", "Failed to modify the domain", "domain does not exit"],
    10132: ["400", "Failed to modify the domain", ""],
    10133: ["400", "Failed to modify the domain", "domain name has exists"],
    10140: ["400", "Failed to delete domain", "no permission"],
    10141: ["400", "Failed to delete domain", ""],
    10142: ["400", "Failed to delete domain", "domain does not exit"],
    10143: ["400", "Failed to delete domain", "in use"],
    10150: ["400", "Failed to obtain domain", "no permission"],
    10151: ["400", "Failed to obtain domain", ""],
    10160: ["400", "Failed to delete group", "need group ID"],
    10161: ["400", "Failed to delete group", "failed to update"],
    10162: ["400", "Failed to delete group", "no permission because of default group"],
    10163: ["400", "Failed to delete group", "group does not exit"],
    10164: ["400", "Failed to delete group", "in use"],
    10165: ["400", "Failed to modify group", "missing parameter"],
    10166: ["400", "Failed to modify group", "failed to update"],
    10167: ["400", "Failed to modify group", "no permission because of default group"],
    10168: ["400", "Failed to modify group", "no group information"],
    10170: ["400", "Failed to create a new group", "missing parameter"],
    10171: ["400", "Failed to create a new group", "failed to update"],
    10172: ["400", "Failed to create a new group", "not allowed to add to default group"],
    10173: ["400", "Failed to create a new group", "group name has exits"],
    10180: ["400", "Failed to upload upgrade packet", "no file"],
    10181: ["400", "Failed to upload upgrade packet", "storage failed"],
    10182: ["400", "Failed to change the upgrade packet", "not exit"],
    10183: ["400", "Failed to delete upgrade packet", "not exit"],
    10184: ["400", "Failed to inquiry upgrade packet", "storage failed"],
    10185: ["400", "Failed to get log", "storage failed"],
    10186: ["400", "Failed to upload upgrade packet", "wrong file name"],
    10187: ["400", "Failed to upload upgrade packet", "wrong base version"],
    10188: ["400", "This version does not support online upgrade", "wrong version"],
    10189: ["400", "Failed to change the upgrade packet", "wrong base version"],
    10190: ["400", "Failed to upload file", "no file"],
    10191: ["400", "Failed to upload file", "storage failed"],
    10192: ["400", "Failed to upload file", "wrong file format"],
    10193: ["400", "Failed to get log", "no permission"],
    10194: ["400", "Failed to get log", "user does not exist"],
    10195: ["400", "Failed to upload upgrade packet", "has exists"],
    10196: ["400", "Failed to upload upgrade packet", "no more than two packages for the same version"],
    10197: ["400", "Failed to operate upgrade packet", "wrong version or wrong model"],
    10198: ["400", "Failed to operate upgrade packet", "database error"],
    10199: ["400", "Failed to list upgrade packets", "wrong parameter"],
    10200: ["400", "Failed to import certificate", "no certificate file"],
    10201: ["400", "Failed to import certificate", "failed to read the certificate"],
    10202: ["400", "Failed to import certificate", "illegal certificate file"],
    10203: ["400", "Failed to import certificate", "no permission"],
    10210: ["400", "Password authentication failed", "wrong password"],
    10211: ["400", "Password authentication failed", "device does not exit"],
    10212: ["400", "Password authentication failed", "database error"],
    10220: ["400", "Failed to add access IP address lists", "missing parameter"],
    10221: ["400", "Failed to add access IP address lists", "user does not exist"],
    10222: ["400", "Failed to add access IP address lists", "no permission"],
    10223: ["400", "Failed to add access IP address lists", "database error"],
    10224: ["400", "Failed to add access IP address lists", "max IP addresses"],
    10230: ["400", "Failed to upgrade access IP address lists", "wrong request message"],
    10231: ["400", "Failed to upgrade access IP address lists", "user does not exist"],
    10232: ["400", "Failed to upgrade access IP address lists", "no permission"],
    10233: ["400", "Failed to upgrade access IP address lists", "not exist"],
    10234: ["400", "Failed to upgrade access IP address lists", "database error"],
    10235: ["400", "Failed to update access IP address lists", "no permission because of not in white list"],
    10240: ["400", "Failed to delete access IP address lists", "wrong request message"],
    10241: ["400", "Failed to delete access IP address lists", "user does not exist"],
    10242: ["400", "Failed to delete access IP address lists", "no permission"],
    10243: ["400", "Failed to delete access IP address lists", "not exist"],
    10244: ["400", "Failed to delete access IP address lists", "database error"],
    10250: ["400", "Failed to get access IP addresses lists", "wrong request message"],
    10251: ["400", "Failed to get access IP addresses lists", "User does not exist"],
    10252: ["400", "Failed to get access IP addresses lists", "no permission"],
    10253: ["400", "Failed to get access IP addresses lists", "not exist"],
    10254: ["400", "Failed to get access IP addresses lists", "database error"],
    10260: ["400", "Failed to add base version", "wrong request message"],
    10261: ["400", "Failed to add base version", "no permission"],
    10262: ["400", "Failed to add base version", "has exists"],
    10263: ["400", "Failed to add base version", "database error"],
    10264: ["400", "Failed to add base version", "wrong version"],
    10270: ["400", "Failed to modify base version", "wrong request message"],
    10271: ["400", "Failed to add base version", "no permission"],
    10272: ["400", "Failed to modify base version", "not exist"],
    10273: ["400", "Failed to modify base version", "database error"],
    10274: ["400", "Failed to modify base version", "wrong version"],
    10280: ["400", "Failed to delete base version", "wrong request message"],
    10281: ["400", "Failed to delete base version", "no permission"],
    10282: ["400", "Failed to delete base version", "not exist"],
    10283: ["400", "Failed to delete base version", "database error"],
    10290: ["400", "Failed to get base version", "wrong message"],
    10291: ["400", "Failed to get base version", "not exist"],
    10292: ["400", "Failed to get base version", "database error"],
    10300: ["400", "No permission", "The device does not belong to this group"],
    10310: ["400", "Failed to upgrade the address for notification server", "database error"],
    10311: ["400", "Failed to upgrade the user name for notification server", "database error"],
    10312: ["400", "Failed to upgrade the password for notification server", "database error"],
    10313: ["400", "Failed to get information for notification server ", "database error"],
    10314: ["400", "Failed to upgrade the notification server", "no permission"],
    10315: ["400", "Failed to get information for notification server ", "no permission"],
    10316: ["400", "Failed to upgrades the language for notification server", "database error"],
    10320: ["400", "Failed to set HTTP server", "wrong request message"],
    10321: ["400", "Failed to set HTTP server", "database error"],
    10322: ["400", "Failed to set HTTP server", "no permission"],
    10330: ["400", "Failed to set UMS configurations", "wrong request message"],
    10331: ["400", "Failed to set UMS configurations", "database error"],
    10332: ["400", "Failed to set UMS configurations", "no permission"],
    10333: ["400", "Failed to set UMS configurations", "wrong IP address"],
    10340: ["400", "Failed to get UMS configurations", "wrong request message"],
    10341: ["400", "Failed to get UMS configurations", "database error"],
    10342: ["400", "Failed to get UMS configurations", "no permission"],
    10343: ["400", "Failed to set white list", "no permission"],
    10344: ["400", "Failed to set white list", "missing parameter"],
    10345: ["400", "Failed to set white list", "no permission"],
    10346: ["400", "Failed to set white list", "missing parameter"],
    10347: ["400", "Failed to set white list", "database error"],
    10350: ["400", "Failed to modify parameter", "no permission"],
    10351: ["400", "Failed to modify template", "no permission"],
    10360: ["400", "Failed to check for upgrade", "no permission"],
    10361: ["400", "Failed to check for upgrade", "no upgrade server"],
    10362: ["400", "Failed to check for upgrade", "no response from upgrade server"],
    10370: ["400", "Upgrade failed", "no permission"],
    10371: ["400", "Upgrade failed", "the newest version"],
    10372: ["400", "Upgrade failed", "upgrade error"],
    10373: ["400", "Upgrade failed", "failed to download installation package"],
    10374: ["400", "Upgrade failed", "need to check for upgrade"],
    10375: ["400", "Upgrading", "upgrading"],
    10385: ["400", "Failed to change the upgrade packet", "wrong version or wrong model"],
    10386: ["400", "Failed to change the upgrade packet", "database error"],
    10387: ["400", "Failed to delete upgrade packet", "wrong version or wrong model"],
    10388: ["400", "Failed to delete upgrade packet", "database error"],
    10400: ["400", "Universal", "wrong request message"],
    10401: ["400", "Failed to upload cloud component", "model without valid platform"],
    10402: ["400", "Universal", "no permission"],
    10410: ["400", "Failed to add event", "no permission"],
    10411: ["400", "Failed to modify event", "no permission"],
    10412: ["400", "Failed to delete event", "no permission"],
    10413: ["400", "Failed to export event", "no permission"],
    10420: ["400", "Authentication failed", "wrong parameter"],
    10421: ["400", "Authentication failed", "database error"],
    10422: ["400", "Authentication failed", "no permission"],
    10423: ["400", "Authentication failed", "in use"],
    10424: ["400", "Authentication failed", "unknown authentication type"],
    10425: ["400", "Authentication failed", "couldn't start with special character"],
    10430: ["400", "Failed to delete upgrade packet", "couldn't delete the package before canceling the upgrade task of the package"],
    10440: ["400", "Failed to add the 'mandatory upgrade'", "wrong request message"],
    10441: ["400", "Failed to add the 'mandatory upgrade'", "database error"],
    10442: ["400", "Failed to add the 'mandatory upgrade'", "no permission"],
    10443: ["400", "Failed to add the 'mandatory upgrade'", "has exists"],
    10444: ["400", "Failed to add the 'mandatory upgrade'", "wrong device_id"],
    10450: ["400", "Failed to delete the 'mandatory upgrade'", "wrong request message"],
    10451: ["400", "Failed to delete the 'mandatory upgrade'", "database error"],
    10452: ["400", "Failed to delete the 'mandatory upgrade'", "no permission"],
    10453: ["400", "Failed to delete the 'mandatory upgrade'", "not exit"],
    10454: ["400", "Failed to delete the 'mandatory upgrade'", "wrong device_id"],
    10460: ["400", "Failed to query device", "wrong request message"],
    10461: ["400", "Failed to query device", "wrong MAC"],
    10462: ["400", "Failed to query device", "failed to get device"],
    10465: ["400", "Diagnosis failure", "wrong request message"],
    10466: ["400", "Diagnosis failure", "no device_id"],
    10467: ["400", "Diagnosis failure", "unknown operation"],
    10468: ["400", "Diagnosis failure", "no response"],
    10470: ["400", "Failed to query service", "wrong request message"],
    10471: ["400", "Failed to query service", "wrong server"],
    10472: ["400", "Failed to query service", "wrong device"],
    10475: ["400", "Failed to create serivce", "wrong request message"],
    10476: ["400", "Failed to create serivce", "failed"],
    10477: ["400", "Failed to create serivce", "wrong device"],
    10478: ["400", "Failed to create serivce", "the server exists"],
    10480: ["400", "Failed to delete serivce", "wrong request message"],
    10481: ["400", "Failed to delete serivce", "failed"],
    10482: ["400", "Failed to delete serivce", "wrong device"],
    10485: ["400", "Failed to upload logs", "wrong request message"],
    10486: ["400", "Failed to upload logs", "failed"],
    10487: ["400", "Failed to upload logs", "wrong device"],
    10490: ["400", "Failed to query P2P client", "wrong request message"],
    10491: ["400", "Failed to query P2P client", "no response"],
    10495: ["400", "Failed to query device status", "wrong request message"],
    10496: ["400", "Failed to query device status", "no response"],
    10500: ["400", "Failed to upload log of pbxrecord", "not device from cloud server"],
    10501: ["400", "Failed to upload log of pbxrecord", "Device is non-existent"],
    10502: ["400", "Failed to upload log of pbxrecord", "failed"],
    20000: ["400", "Common", "wrong request message"],
    20010: ["400", "Failed to add device", "wrong request message"],
    20011: ["400", "Failed to add device", "exists"],
    20012: ["400", "Failed to add device", "database error"],
    20013: ["400", "Failed to add device", "wrong MAC"],
    20014: ["400", "Failed to add device", "max devices"],
    20015: ["400", "Failed to add device", "group does not exit"],
    20016: ["400", "Failed to add device", "no permission"],
    20020: ["400", "Failed to delete device", "not exit"],
    20021: ["400", "Failed to delete device", "missing parameter ot database error"],
    20022: ["400", "Failed to delete device", "no permission"],
    20030: ["400", "Failed to upgrade device", "wrong request message"],
    20031: ["400", "Failed to upgrade device", "not exit"],
    20032: ["400", "Failed to upgrade device", "database error"],
    20033: ["400", "Failed to upgrade the connection status", ""],
    20034: ["400", "Update device", "no response from remote erver"],
    20035: ["400", "Failed to upgrade device", "group does not exit"],
    20036: ["400", "Failed to upgrade device", "no permission"],
    20037: ["400", "Failed to upgrade device", "setting error"],
    20040: ["400", "Failed to check device", "wrong device"],
    20041: ["400", "Failed to check device", "no permission"],
    20042: ["400", "Failed to get device history", "only device from cloud server"],
    20043: ["400", "Failed to get device history", "failed"],
    20050: ["400", "Failed to check device list", "wrong request message"],
    20051: ["400", "Failed to check device list", "no permission"],
    20060: ["400", "Failed to scan the device", "wrong request message"],
    20061: ["400", "Failed to scan the device", "wrong device"],
    20062: ["400", "Failed to scan the device", "no permission"],
    20063: ["400", "Failed to scan the device", "scanning"],
    20070: ["400", "Failed to import device", "wrong request message"],
    20071: ["400", "Failed to import device", "database error"],
    20072: ["400", "Failed to import device", "create a new task to import the devices when the total is more than 500"],
    20073: ["400", "Failed to import device", "partial import failed because of the license "],
    20074: ["400", "Failed to import device", "no permission"],
    20080: ["400", "Failed to export device", "wrong request message"],
    20081: ["400", "Failed to export device", "database error"],
    20082: ["400", "Failed to export device", "no permission"],
    20090: ["400", "Failed to export status for device", "wrong request message"],
    20091: ["400", "Failed to export status for device", "database error"],
    20092: ["400", "Failed to export status for device", "no permission"],
    20100: ["400", "Error for backing up the .tar file", "wrong request message"],
    20101: ["400", "Error for backing up the .tar file", "database error"],
    20102: ["400", "Error for backing up the .tar file", "no response from device"],
    20103: ["400", "Error for backing up the .tar file", "error response from device"],
    20104: ["400", "Failed to back up the .tar file", "no permission"],
    20110: ["400", "Error for sending the .tar file", "wrong request message"],
    20111: ["400", "Error for sending the .tar file", "database error"],
    20112: ["400", "Error for sending the .tar file", "error response from server"],
    20113: ["400", "Error for sending the .tar file", "error response from device"],
    20114: ["400", "Error for sending the .tar file", "no response from device"],
    20115: ["400", "Failed to send the .tar file", "no permission"],
    20120: ["400", "Task failed", "wrong request message"],
    20121: ["400", "Task failed", "no Mac"],
    20122: ["400", "Task failed", "missing parameter"],
    20123: ["400", "Task failed", "database error"],
    20124: ["400", "Task failed", "wrong template"],
    20125: ["400", "Task failed", "wrong parameter"],
    20126: ["400", "Task failed", "invalid parameter"],
    20127: ["400", "Task failed", "unknown task name"],
    20128: ["400", "Task failed", "no permission"],
    20130: ["400", "Failed to find task", "database error"],
    20140: ["400", "Failed to view task list", "wrong request message"],
    20141: ["400", "Failed to view task list", "no permission"],
    20150: ["400", "Failed to view parameter database list", "wrong request message"],
    20151: ["400", "Failed to view parameter", "not exit"],
    20160: ["400", "Failed to add parameter database", "no ID"],
    20161: ["400", "Failed to add parameter database", "exits"],
    20162: ["400", "Failed to add parameter database", "wrong model"],
    20170: ["400", "Failed to delete parameter database", "wrong request message"],
    20171: ["400", "Failed to delete parameter database", "database error"],
    20172: ["400", "Failed to delete parameter database", "not exit"],
    20179: ["400", "Failed to download logs", "no permission"],
    20180: ["400", "Failed to download logs", "wrong request message"],
    20181: ["400", "View the log list", "wrong request message"],
    20182: ["400", "Failed to download running logs", "wrong request message"],
    20183: ["400", "Failed to download logs", "not exit"],
    20184: ["400", "Failed to download logs", "failed because the accessing USB storage of device is disable"],
    20185: ["400", "Failed to download logs", "database error"],
    20186: ["400", "Failed to download logs", "error response from device"],
    20187: ["400", "Failed to download logs", "no response from device"],
    20188: ["400", "Failed to download logs", "wrong device model for downloading log"],
    20189: ["400", "Failed to download logs", "wrong date"],
    20190: ["400", "Failed to upgrade parameter", "wrong request message"],
    20191: ["400", "Failed to upgrade parameter", "not exit"],
    20192: ["400", "Failed to upgrade parameter", "database error"],
    20193: ["400", "Failed to upgrade parameter", "ID exists"],
    20200: ["400", "Failed to view call history", "wrong request message"],
    20201: ["400", "Failed to view call history", "database error"],
    20202: ["400", "Failed to export call history", "database error"],
    20210: ["400", "Failed to import parameter", "wrong request message"],
    20220: ["400", "Failed to set comparison", "wrong request message"],
    20221: ["400", "Failed to set comparison", "not exist"],
    20230: ["400", "Failed to add template", "wrong type of template"],
    20231: ["400", "Failed to add template", "wrong request message"],
    20232: ["400", "Failed to add template", "database error"],
    20233: ["400", "Failed to add template", "exists"],
    20234: ["400", "Failed to create a new configuration", "exits"],
    20235: ["400", "Failed to create a new configuration", "wrong request message"],
    20236: ["400", "Failed to create a new configuration", "database error"],
    20237: ["400", "Failed to get configuration", "not exit"],
    20238: ["400", "Failed to get deploy history", "not exit or database error"],
    20239: ["400", "Failed to get deploy task", "not exit or database error"],
    20240: ["400", "Failed to get template", "not exist or database error"],
    20241: ["400", "Failed to get template", "no permission"],
    20242: ["400", "Failed to create a new deploy task", "wrong request message"],
    20243: ["400", "Failed to upgrade deploy task", "wrong request message"],
    20244: ["400", "Failed to upgrade deploy task", "not exit"],
    20245: ["400", "Failed to get phone number", "not exit or database error"],
    20246: ["400", "Failed to delete phone number", "not exit or database error"],
    20247: ["400", "Failed to create a new phone number", "wrong request message"],
    20248: ["400", "Failed to upgrade phone number", "wrong request message"],
    20249: ["400", "Failed to upgrade phone number", "wrong phone number"],
    20250: ["400", "Failed to delete template", "not exit"],
    20251: ["400", "Failed to delete template", "database error"],
    20252: ["400", "Failed to delete template", "no permission"],
    20253: ["400", "Failed to create a new phone number", "database error"],
    20254: ["400", "Failed to create a new phone number", "wrong phone number or wrong MAC"],
    20255: ["400", "Failed to upgrade phone number", "wrong phone number or wrong MAC"],
    20260: ["400", "Failed to upgrade template", "wrong request message"],
    20261: ["400", "Failed to upgrade template", "not exit"],
    20262: ["400", "Failed to upgrade template", "database error"],
    20263: ["400", "Failed to upgrade template", "exits"],
    20266: ["400", "Failed to upgrade template", "no permission"],
    20270: ["400", "Failed to recover parameter settings", "wrong device"],
    20271: ["400", "Failed to recover parameter settings", "no url of device"],
    20272: ["400", "Failed to recover parameter settings", "backup history does not exist"],
    20273: ["400", "Failed to recover parameter settings", "no template"],
    20274: ["400", "Failed to recover parameter settings", "no response"],
    20275: ["400", "Failed to recover parameter settings", "no Mac"],
    20280: ["400", "Failed to upgrade task", "wrong request message"],
    20281: ["400", "Failed to upgrade task", "not exit"],
    20282: ["400", "Failed to upgrade task", "only remarks of disposable task"],
    20283: ["400", "Failed to upgrade task", "wrong time"],
    20284: ["400", "Failed to upgrade task", "database error"],
    20285: ["400", "Failed to upgrade task", "task has been canceled"],
    20286: ["400", "Failed to upgrade task", "task in progress"],
    20290: ["400", "Failed to upgrade history for backing up parameters", "not exist"],
    20291: ["400", "Failed to upgrade history for backing up parameters", "database error"],
    20292: ["400", "Failed to upgrade history for backing up parameters", "wrong request message"],
    20300: ["400", "Failed to configure device", "no permission or no password or no url or wrong status"],
    20301: ["400", "Wrong password", ""],
    20302: ["400", "Wrong password", "been locked for 10 minutes because of too many times of wrong password "],
    20310: ["400", "Failed to modify remark", "wrong request message"],
    20311: ["400", "Failed to modify remark", "database error"],
    20312: ["400", "Failed to modify remark", "not exit"],
    20320: ["400", "Failed to delete task", "wrong request message"],
    20321: ["400", "Failed to delete task", "not exit"],
    20322: ["400", "Failed to delete task", "database error"],
    20323: ["400", "Failed to delete task", "task in progress"],
    20324: ["400", "Failed to delete task", "no permission"],
    20330: ["400", "Failed to clear date", "wrong request message"],
    20331: ["400", "Failed to clear date", "database error"],
    20340: ["400", "Failed to back up data", "wrong request message"],
    20341: ["400", "Failed to back up data", "database error"],
    20342: ["400", "Backing up and recovering data are not supported", "The database is not in the same machine with the EMS"],
    20350: ["400", "Failed to obtain data", "wrong request message"],
    20351: ["400", "Failed to obtain data", "database error"],
    20360: ["400", "Failed to export template", "wrong request message"],
    20361: ["400", "Failed to export template", "database error"],
    20370: ["400", "Failed to import template", "wrong request message"],
    20371: ["400", "Failed to import template", "database error"],
    20380: ["400", "Failed to add a task of auto upgrade", "wrong request message"],
    20381: ["400", "Failed to add a task of auto upgrade", "database error"],
    20390: ["400", "Failed to recover data", "wrong request message"],
    20391: ["400", "Failed to recover data", "database error"],
    20400: ["400", "Failed to view event definition", "database error"],
    20410: ["400", "Failed to delete event definition", "not exit"],
    20411: ["400", "Failed to delete event definition", "database error"],
    20420: ["400", "Failed to add event definition", "wrong request message"],
    20421: ["400", "Failed to add event definition", "database error"],
    20422: ["400", "Failed to add event definition", "exist"],
    20423: ["400", "Failed to import events", "database error"],
    20424: ["400", "Failed to export event", "database error"],
    20430: ["400", "Failed to upgrade event definition", "wrong request message"],
    20431: ["400", "Failed to upgrade event definition", "database error"],
    20432: ["400", "Failed to upgrade event definition", "not exit"],
    20440: ["400", "Failed to view collection event", "database error"],
    20445: ["400", "Failed to upgrade collection event", "not exit"],
    20446: ["400", "Failed to upgrade collection event", "database error"],
    20450: ["400", "Failed to upgrade the switch for device event", "wrong request message"],
    20451: ["400", "Failed to upgrade alarm rules of device", "not exit"],
    20452: ["400", "Failed to upgrade the switch for device event", "failed to configure device"],
    20453: ["400", "Failed to upgrade alarm rules of device", "wrong request message"],
    20454: ["400", "Failed to upgrades alarm rules of device", "database error"],
    20460: ["400", "No permission", "the device does not belong to this user"],
    20461: ["400", "Failed", "device does not exit"],
    20462: ["400", "Failed", "no permission"],
    20470: ["400", "Failed to view alarm rules", "database error"],
    20471: ["400", "Failed to add alarm rules", "wrong request message"],
    20472: ["400", "Failed to add alarm rules", "database error"],
    20473: ["400", "Failed to obtain alarm rules", "database error"],
    20474: ["400", "Failed to delete alarm rules", "not exit"],
    20475: ["400", "Failed to delete alarm rules", "database error"],
    20476: ["400", "Failed to upgrade alarm rules", "not exit"],
    20477: ["400", "Failed to upgrade alarm rules", "wrong request message"],
    20478: ["400", "Failed to upgrade alarm rules", "database error"],
    20479: ["400", "Failed to delete alarm rules", "in use"],
    20480: ["400", "Failed to view alarm list", "database error"],
    20481: ["400", "Failed to obtain alarm information", "database error"],
    20482: ["400", "Failed to add alarm rules", "rule of same event exits"],
    20483: ["400", "Failed to confirm the alarm", "database error"],
    20484: ["400", "Failed to confirm the alarm", "not exit"],
    20485: ["400", "Failed to add alarm rules", "no authorization of WeChat or mailbox"],
    20486: ["400", "Failed to upgrade alarm rules", "no authorization of WeChat or mailbox"],
    20487: ["400", "Failed to upgrade alarm rules", "no permission"],
    20488: ["400", "Failed to delete alarm rules", "no permission"],
    20490: ["400", "Failed to modify the upgrade task", "wrong request message"],
    20491: ["400", "Failed to modify the upgrade task", "database error"],
    20492: ["400", "Failed to modify the upgrade task", "task in process"],
    20493: ["400", "Failed to modify the upgrade task", "not exit"],
    20494: ["400", "Failed to modify the upgrade task", "task in process"],
    20495: ["400", "Failed to deletethe upgrade task", "wrong request message"],
    20496: ["400", "Failed to deletethe upgrade task", "database error"],
    20497: ["400", "Failed to deletethe upgrade task", "task has not done"],
    20498: ["400", "Failed to deletethe upgrade task", "not exit"],
    20499: ["400", "Failed to deletethe upgrade task", "no permission"],
    20500: ["400", "Failed to add WeChat account", "failed to get WeChat user information"],
    20501: ["400", "Failed to add WeChat account", "Wechat server error"],
    20502: ["400", "Failed to add WeChat account", "Internal server communication error"],
    20503: ["400", "Failed to add WeChat account", "Failed to get Wechat user"],
    20510: ["400", "Access to the device is restricted, Please add the IP address of UMS to trust IP address group"],
    20520: ["400", "Failed to create a template for configuration file", "wrong request message"],
    20521: ["400", "Failed to create a template for configuration file", "database error"],
    20522: ["400", "Failed to create a template for configuration file", "no response from device"],
    20523: ["400", "Failed to create a template for configuration file", "error response from device"],
    20524: ["400", "Failed to create a template for configuration file", "no permission"],
    20525: ["400", "Failed to create a template for configuration file", "error response from server"],
    20526: ["400", "Failed to create a template for configuration file", "exists"],
    20530: ["400", "Failed to assign cloned configurations", "wrong request message"],
    20531: ["400", "Failed to assign cloned configurations", "database error"],
    20532: ["400", "Failed to assign cloned configurations", "error response from server"],
    20533: ["400", "Failed to assign cloned configurations", "error response device"],
    20534: ["400", "Failed to assign cloned configurations", "no response from device"],
    20535: ["400", "Failed to assign cloned configurations", "no permission"],
    20540: ["400", "Failed to modify template for configuration files", "wrong request message"],
    20541: ["400", "Failed to modify template for configuration files", "database error"],
    20542: ["400", "Failed to modify template for configuration files", "not exit"],
    20543: ["400", "Failed to modify template for configuration files", "no permission"],
    20544: ["400", "Failed to modify template for configuration files", "error response from server"],
    20550: ["400", "Failed to delete template for configuration files", "wrong request message"],
    20551: ["400", "Failed to delete template for configuration files", "database error"],
    20552: ["400", "Failed to delete template for configuration files", "not exit"],
    20553: ["400", "Failed to delete template for configuration files", "no permission"],
    20560: ["400", "Failed to set phone", "wrong request message"],
    20561: ["400", "Failed to set phone", "database error"],
    20562: ["400", "Failed to set phone", "disabled"],
    20563: ["400", "Failed to set phone", "no permission"],
    20564: ["400", "Failed to set phone", "not allowed"],
    20570: ["400", "Failed to get the templates of configuration file", "wrong request message"],
    20571: ["400", "Failed to get the templates of configuration file", "database error"],
    20572: ["400", "Failed to get the templates of configuration file", "not exit"],
    20573: ["400", "Failed to get the templates of configuration file", "no permission"],
    20574: ["400", "Failed to get the templates ofconfiguration file", "error response from server"],
    20580: ["400", "Email server test failure", "wrong request message"],
    20581: ["400", "Email server test failure", "invalid account"],
    20582: ["400", "Email server test failure", "mail server setting error"],
    20583: ["400", "Email server test failure", "connection timeout for incorrect address or unreachable network."],
    20584: ["400", "Email server test failure", "no password"],
    20585: ["400", "Email server test failure", "authentication timeout or wrong password or wrong account "],
    20586: ["400", "Email server test failure", "authentication timeout or wrong password or wrong account"],
    20590: ["400", "Failed to upgrade notification server", "database error"],
    20591: ["400", "Failed to upgrade notification server", "wrong request message"],
    20600: ["400", "Failed to delete records for backing up parameters", "wrong request message"],
    20601: ["400", "Failed to delete records for backing up parameters", "not exit"],
    20602: ["400", "Failed to delete records for backing up parameters", "database error"],
    20605: ["400", "Failed to delete records for backing up configurations", "wrong request message"],
    20606: ["400", "Failed to delete records for backing up configurations", "not exit"],
    20607: ["400", "Failed to delete records for backing up configurations", "database error"],
    20610: ["400", "Failed to delete records for backing up logs", "wrong request message"],
    20611: ["400", "Failed to delete records for backing up logs", "not exit"],
    20612: ["400", "Failed to delete records for backing up logs", "database error"],
    20620: ["400", "Failed to create a new monitor group", "wrong request message"],
    20621: ["400", "Failed to create a new monitor group", "database error"],
    20622: ["400", "Failed to create a new monitor group", "exit"],
    20623: ["400", "Failed to get monitor group", "not exit"],
    20624: ["400", "Wrong type of monitor group", "wrong request message"],
    20630: ["400", "Failed to delete monitor group", "wrong request message"],
    20631: ["400", "Failed to delete monitor group", "database error"],
    20632: ["400", "Failed to delete monitor group", "not exit"],
    20640: ["400", "Failed to upgrade monitor group", "wrong request message"],
    20641: ["400", "Failed to upgrade monitor group", "database error"],
    20642: ["400", "Failed to upgrade monitor group", "not exit"],
    20643: ["400", "Failed to upgrade monitor group", "exit"],
    20650: ["400", "Failed to get statistics of Wewei", "wrong device"],
    20651: ["400", "Failed to get statistics of Wewei", "no response"],
    20652: ["400", "Failed to get statistics of Wewei", "wrong device ID or wrong token"],
    20700: ["400", "Failed to configure", "wrong request message"],
    20701: ["400", "Failed to configure", "not exit"],
    30000: ["400", "Common", "wrong request message"],
    30020: ["400", "Failed to get the statistics of Wewei", "wrong request message"],
    30021: ["400", "Failed to get the statistics of Wewei", "no response"],
    30030: ["400", "Failed to get the statistics records", "wrong request message"],
    30031: ["400", "Failed to get the statistics records", "no response"],
    30032: ["400", "Statistic", "in process"],
    30040: ["400", "Failed to delete the log of pbxrecord", "wrong request message"],
    30041: ["400", "Failed to delete the log of pbxrecord", "not exit"],
    30042: ["400", "Failed to delete the log of pbxrecord", "database error"],
    30050: ["400", "Failed to download the log of pbxrecord", "wrong request message"],
    30051: ["400", "Failed to download the log of pbxrecord", "database error"],
    30052: ["400", "Failed to download the log of pbxrecord", "no response from cloud server"],
    30053: ["400", "Download", "in process"],
    30060: ["400", "Failed to get the statistics of pbxrecord", "wrong request message"],
    30061: ["400", "Failed to get the statistics of pbxrecord", "database error"],
    30070: ["400", "Failed to delete reports", "wrong request message"],
    30071: ["400", "Failed to delete reports", "not exit"],
    30072: ["400", "Failed to delete reports", "database error"],
    30080: ["400", "Failed to get applications", "wrong request message"],
    30081: ["400", "Failed to get applications", "not exit"],
    30082: ["400", "Failed to get applications", "database error"],
    30090: ["400", "Failed to upgrade application", "wrong request message"],
    30091: ["400", "Failed to upgrade application", "not exit"],
    30092: ["400", "Failed to delete application", "database error"],
    30100: ["400", "Failed to delete application", "wrong request message"],
    30101: ["400", "Failed to delete application", "not exit"],
    30102: ["400", "Failed to delete application", "database error"],
    40000: ["400", "Common", "wrong request message"],
    40001: ["400", "Failed", "no support"],
    50000: ["400", "Common", "not support"],
    50001: ["400", "Common", "wrong request message"],
    50002: ["400", "Common", "missing parameter"],
    50003: ["400", "Common", "no permission"],
    2053: ["500", "Timeout", "Internel error"],
    2503: ["500", "Timeout", "Internel error"],
    20872: ["400", "Failed to add large screen configuration", "database error"],
  },

  bigScreen: {
    'title': 'UMS system monitoring large screen',
    'leftTopTitle': 'Use ratio',
    'leftTopItem1': 'In concurrent',
    'leftTopItem2': 'Out concurrent ',
    'leftTopItem3': 'Extension calls',
    'leftMiddleTitle': 'IP status',
    'leftMiddleItem1': 'OnLine',
    'leftMiddleItem2': 'OffLine',
    'leftMiddleItem3': 'Register exception',
    'leftBottomTitle': 'SIP status',
    'leftBottomItem1': 'Register success',
    'leftBottomItem2': 'Registration failed',
    'leftBottomItem3': 'Peer trunk/unregistered',
    'alarmNum': 'Total real-time concurrency',
    'CPU': 'CPU',
    'RAM': 'RAM',
    'LOCAL': 'Local',
    // 'centerBottomTitle':'Device status',
    'onlineDevice': 'Online devices',
    'offlineDevice': 'Offline devices',
    'isdnCallStatisc': 'ISDN',
    'device': 'Device',
    'bTotal': 'Total concurrent',
    'deviceStatus': 'Device status',
    'alarm': 'Alarm list',
    'peakCall': 'Peak call concurrency',
    "urgent": "Urgent",
    "important": "Important",
    "generally": "Generally",
    "addModalAddTitle": 'Please add a large screen configuration',
    "modModalAddTitle": 'Please edit the large screen configuration',
    "chartTypeLabel": 'Name',
    "concurrencyStatistics": 'Concurrency statistics',
    "alarmStatistics": 'Alarm Statistics',
    "img": 'Image',
    "device1": '1# MAC',
    "device2": '2# MAC',
    "hostInput": "Please select a No.1 machine from the list",
    "slaveInput": "Please select a No.2 machine from the list",
    "allDevice": '* Note: All devices',
    "tgDevice": '* Note: All TG devices',
    "preview": 'Preview',
    "confrimDel": 'Are you sure you want to delete this chart?',
    "sunday": "Sunday",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "template": "Sample",
    "mainDevice": 'Master',
    "standby ": "Slave",
    "workOrder": "Work order",
    "workOrder1": "Yi Xun Work order",
    "serverUrl": 'Server address',
    "inputServerUrl": 'http://ip:port',
    "addNum": "Up to 10 groups can be added",
    "addTips": 'Add at least one set of devices',
    "addTips2": '1#MAC is not empty',
    "addTips3": 'Multiple device groups cannot be edited at the same time'
  },

  //--om/mx设备下发列表
  issueList: {
    issueStatus: 'Issue status',
    issueMode: 'Issue mode',
    noConfig: 'Not configured',
    Config: 'Configured',
    issued: 'Done',
    unissue: 'Ready',
    theRemote: 'Remote',
    local: 'Local'
  },
  ACSservice: {
    acsService: 'ACS service',
    redirect: 'Autoprovision',
    management_template: 'Profile management',
    device_redirect: 'Device management',
    noConfig: 'Not configured',
    acsPath: 'ACS address',
    autoLabel1: 'Obtain the ACS address using DHCP option 66 ',
    autoLabel2: 'Firmware update',
    autoLabel3: 'Update mode',
    autoLabel4: 'Update cycle',
    autoLabel5: 'access to electricity',
    autoLabel6: 'Power on + cycle',
    autoLabel7: 'Seconds (range: 5~86400)',
    autoLabel8: 'eg:protocol://211.168.5.153,protocol:http,https,tftp,ftp',
    acsLabel1: "Mode:",
    acsLabel2: "Username:",
    acsLabel3: "Password:",
    acsLabel4: "Port:",
    acsLabel5: "Path:",
    saveSuccess: 'Saved successfully',
    addTemplate: 'Please enter template information',
    selectMode: 'Please select update mode',
    templateTab1: 'Name',
    templateTab2: 'Remarks',
    templateTab3: 'Template name',
    delSuccess: 'Template deleted successfully',
    addTempSuccess: 'Template created successfully',
    modTempSuccess: 'Template modified successfully',
    msg1: 'Please enter name',
    msg2: 'Update cycle must be numeric',
    msg3: 'Update period ranges from 5 to 86400',
    msg4: 'Please enter remarks',
    msg5: 'Please enter ACS address',
    autoDeviceTemplate: 'Template',
    selectTemplate: 'Please select meta profile',
    tips: 'Create domain administrator when role is default',
    default: 'default',
    noexist: '(Deleted)',
    allDomain: 'All'
  },
  metaprofile: {
    metaprofileMenu: 'Meta profile',
    functionType: 'Attribution',
    templateConfig: 'Profile configuration',
    baseInfo: 'Basic information',
    paramList: "Parameter list",
    nextStep: 'Next',
    prevStep: 'Prev',
    msg1: 'This parameter is not currently supported',
    confrimInfo: 'Confirm information',
    addParamsInfo: 'Click the plus sign in front of the parameter list to add a parameter template',
    addErrorMsg: 'Parameter list already exists',
    switchTip: '*The switching operation will clear the added parameter list',
    msg2: 'The parameter list cannot be empty',
    msg3: '* Without selecting a domain, the profile is available to all domains.',
    msg4: '* If the value is null, the device is unbound from the template',
    msg5: 'Set the parameter display in the parameter list',
  },
  sysmonitor: {
    headerTitle: 'System monitor',
    monitorMessage: 'Customize message:',
    confirmDelWechats: "After the deletion is successful, the system does not notify the wechat of alarms"
  },


  message: {
    msg1: "Please select at least one group"
  },
  appStat: {
    active: 'Activity',
    recordData: 'Recording data',
    quantity: 'Quantity',
    activeBoard: 'Active leaderboard'
  },
  actomDetail: {
    registered: 'Registered',
    accountActive: 'Account activation',
    actomDetail: 'Disable',
    formLabelTag: 'Display tag',
    formLabelName: 'Display Name',
    registName: 'Authentication name',
    userName: 'Username',
    sipServer: 'SIP backup server',
    outbound: 'Outbound proxy',
    dtmfType: 'DTMF type',
    subscription: 'Subscription period (s)',
    localsipPort: 'Local SIP port',
    timeOut: 'TimeOut(s)',
    udpTime: 'UDP keep-alive message sending interval(s)',
    udpMsg: 'UDP keep-alive message',
    stunServer: 'STUN server',
    nat: 'NAT penetration',
    tlsVersion: 'TLS version',
    outboundStatus: 'Outbound status',
    unregistMode: 'Unregistered dialing mode',
    transport: 'Transmission method',
    account1: 'Account 1',
    account2: 'Account 2',
    account3: 'Account 3',
    account4: 'Account 4',
    account5: 'Account 5',
    account6: 'Account 6',
    nomodify: 'There is no change',
    ipphoneBusy: 'Phone is busy',
    saveFail: 'Save failed',
    disableEncoding: 'Disable encoding',
    enableEncoding: 'Enable encoding',
    callForwarding: 'Call forward',
    callNum: 'Call transfer emergency number',
    callForwardnum: 'Call transfer authentication number',
    model: 'model',
    transfer: 'Unconditional transfer',
    nodisOff: 'DND disabled feature code',
    nodisOn: 'DND Enables the feature code',
    offCode: 'Off signature',
    onCode: 'On signature',
    targetNum: 'Target number',
    nodisStauts: 'DND state',
    ipphone: 'IPPHONE',
    nodisnum: 'DND authentication number',
    nodisNum1: 'DND emergency number',
    busyTransfer: 'Busy',
    replaceRule: 'Replace the rules',
    prefix: 'Prefix',
    replace: 'Replace',
    application: 'Apply',
    immediatelyCall: 'Breathe out immediately',
    lcode: 'Area code',
    areaCode: 'Destinations',
    minlen: 'Minimum length',
    maxLen: 'Maximum length',
    exhaleLimit: 'Call limit',
    limitNum: 'LimitNum',
    selectDel: ' Please select data to delete',
    tip1: 'Prefix and replace with non-null ',
    tip2: 'Exhale now not empty',
    errMsg1: 'Minimum range error',
    errMsg2: 'Maximum range error',
    errFile: 'Invalid file',
    uploadOneFile: 'Upload only one file at a time',
    uploadCfg: 'Please upload file in CFG format',
    exportFile: 'Import/export CFG file',
    clickUpload: 'Click to upload',
    clickUpload1: 'Click to get the file and select the file to upload',
    exportSysLog: 'Export system logs',
    fatalError: 'Fatal error',
    warning: 'Warning',
    info: 'Info',
    debug: 'Debug',
    server: 'Server',
    logArea: 'Log position',
    serverName: 'Server name',
    callfun: 'Ipphone function setting', //ipphone
    dialPlan: 'No rules',
    codecSet: 'Media Setting ',
    sysConfig: 'System Configuration',
    confirmReboot: 'Are you sure you want to restart?',
    rebootSuccess: 'Restart the success',
    rebootFail: 'Restart the failure',
    modNot: 'Do not change the password',
    softwareVersion: 'Software version',
    hardwareVersion: 'Hardware version',
    codec: 'Enabled codecs',
    dialingRules: 'dialing method',
    staticsChart: 'Put the stats here',
    detailList: 'Here is the detailed list',
    delLicense: 'Sure you want to delete the {name} certificate?',
    operationCodeRequired: 'Opcode required',
    testInterval: 'TestInterval',
    testNum: 'Number of tests',
    successNum: 'Number of successes',
    failNum: 'number of failures',
    counts: 'Frequency',
    completeTime: 'Completion time',
    askCancel: "Are you sure you want to cancel the task? , continue?",
    cancelSucess: 'Cancel the success',
    execuNum: 'Number of executions',
    validate1: 'Contains only numbers and decimal points',
    validate2: 'The format is incorrect',
    cloneing: 'Cloning in progress, please wait...',
    config: 'Configuration',
    inputconfigName: 'Please enter a configuration file name',
    configNull: 'Configuration cannot be empty ',
    modCycle: 'Change update cycle',
    tokenverify:"Verification mode",
    tokenmode:"Token mode"
  },
  ipphoneInfo: {
    callWait: 'Enable call waiting',
    callForward: 'Allow call forwarding',
    halfForward: 'Allow half attendance forward',
    threeMetting: 'Allow three-way meetings',
    standby: 'Call automatically returns to standby',
    autohangup: 'Auto hangup time',
    silentMode: 'Enable silent mode',
    silentRing: 'Silence the ringtone',
    defaultLine: 'Turn on defaultLine',
    autoSwitchLine: 'Enable automatic line switching',
    defaultOutLine: 'Default call outside line',
    disableOutbount: 'Disable outgoing calls',
    hiddenDtmf: 'Hidden DTMF',
    saveCallhistory: 'SaveCallhistory',
    enablelimitList: 'Enable restricted call list',
    enablecallList1: 'Enable call list',
    enablecallList2: 'Enable restricted dialing list',
    enableCountryCode: 'Enable country code',
    countryCode: 'Country code',
    stop: 'Disabled',
    delay: 'Delay',
    endShow: 'Show at the end',
    enableNumprivacy: 'Enable number privacy',
    matchDirection: 'Match direction',
    leftToRight: 'LeftToRight',
    rightToLeft: 'RightToLeft',
    startPosition: 'Start position',
    hiddenBits: 'HiddenBits',
    allowIPCall: 'AllowIP calls',
    firstCallerName: 'Calling name display priority',
    sipName1: 'Local phonebook - Netphonebook - SIP display name',
    sipName2: 'Local phonebook - SIP display name - Netphonebook',
    sipName3: 'Netphonebook - Local Phonebook - SIP display name',
    sipName4: 'Netphonebook - SIP display name - Local phonebook',
    sipName5: 'SIP display name - Local Phonebook - Netphonebook',
    sipName6: 'SIP display name- Netphonebook - Local Phonebook',
    emergencyNumber: 'Emergency call number',
    searchScope: 'Contact searchScope',
    localConcat: 'Local contacts only',
    ldapLocal: 'ldap and local contacts',
    ldapSearch: 'ldap search',
    callerModel: 'Calling information display mode',
    firstDisplayName: 'FirstDisplayName',
    onlyNum: 'Show number only',
    displayEmpty: 'Show blank',
    normal: 'Normal',
    limitActive: 'Limit Active URI source IP',
    XMLServerUrl: 'XML push server address',
    allowPredial: 'AllowPredial numbers',
    onMultiLine: 'Enable Multi Line',
    customLineformat: 'CustomLineformat',
    whiteListType: 'Local contacts as whitelist-type',
    dialnumber: 'Press # to dial the number',
    lenDailNum: 'Fixed length dial',
    fixedLength: 'FixedLength',
    endTransfer: 'blind transfer ending with #',
    hangBlind: 'HangBlind',
    hangOutBlind: 'Hang up attend transfer',
    threeTransfer: 'Three party hang up attend transfer ',
    enablee: 'Enable E.164',
    timeOutDail: 'Timeout dial',
    miao330: ' s (3~30)',
    dial: 'Dial',
    proxyServerIp1: 'Proxy server address',
    proxyServerIp2: 'Backup proxy server address',
    proxyServerPort1: 'Proxy server port',
    proxyServerPort2: 'Backup proxy server port',
    proxyUser: 'Proxy user',
    proxyPass: 'Proxy pass',
    userAuth: 'User authentication',
    verificationPass: 'Verify password',
    registrationValidity: 'RegistrationValidity',
    serverIP: 'Server address',
    serverPort: 'server port',
    transportProtocol: 'Transfer protocol',
    exportConfig: 'Export configuration',
    importConfig: 'import configuration',
    txtConfig: 'TXT configuration',
    ncConfig: 'NC configuration',
    xmlConfig: 'XML configuration',
    onSyslog: 'Enable system log',
    syslogServerIP: 'System log server address',
    syslogServerPort: 'System log server port ',
    syslogLevel: 'Syslog level',
    exportLog: 'Export log',
    factory: 'Factory',
    serialNum: 'Seq', //序号
    unuseMemory: 'Remaining memory',
    residualFlash: 'Remainin Flash',
    runningTime: 'Running time',
  },
  monitorPage: {
    'modalTitle': 'Please add devices',
    'normal': 'Normal',
    'unConnected': 'Not connected',
    'macAddress': 'MAC:',
    'line1': 'Line 1',
    'line2': 'Line 2',
    'line3': 'Line 3',
    'line4': 'Line 4',
    'alarmNum': "There are currently {num} alarms",
    'goAdd': "There is currently no device added, please go to add",
    'frontPanel': "Front Panel",
    'rearPanel': "Rear Panel",
    'chassis1': "Chassis",
    // 'chassis2':"机箱号",
    'fan': "Fan",
    'fault': "Fault",
    'disableManually': "Manually disable",
    'working': "Working",
    'standing': "Standing",
    'cidShow': "CID:",
    'isdnStatus': "ISDN line status diagram",
    'tip1': 'Note: The two AUX ports in the rear panel communicate with each other, and the status of the two lights can be modified at the same time',
    'lost': 'Lost',
    'wareLost': 'Hardware configuration is missing',
    'status': 'Status:',
    'deviceMode': 'Device mode:',
    'disabled': 'Disabled',
    'active': 'Active',
    'standby': 'Standby',
    'error': 'Error',
    'waiting': 'Waiting',
    'primary': 'Primary',
    'secondary': 'Secondary',

  },
  sbcConf: {
    itspServer: 'ITSP server',
    serverPort: 'Service port',
    seq: 'ID',
    response: 'Sending response via rport',
    yes: 'Yes',
    no: 'No',
    netPort1: 'ETH1',
    netPort2: 'ETH2',
    netPort3: 'ETH3',
    netPort4: 'ETH4',
    port: 'Port',
    itspSeq: 'Index of ITSP server',
    backupSwitch1: 'Index of backup ITSP server 1',
    backupSwitch2: 'Index of backup ITSP server 2',
    voiceEncryption: 'RTP encryption',
    encryption: 'Encryption method',
    encryptionKey: 'Encryption key',
    null: 'None',
    telnetServer: 'Telnet service',
    sshServer: 'SSH service',
    telsshPass: 'Telnet/SSH password',
    itspMsg1: 'The configuration takes effect after the system is restarted.',
    itspMsg2: 'Configuration format error',
    itspMsg3: 'Configuration saving failed',
    itspMsg4: 'Failed to get data',
    itspMsg5: 'At least 8 letters, numbers or !@ # $^. Case sensitive',
    itspMsg6: 'Save failed',
    itspMsg7: 'Save successfully',
  },
  server: {
    management_police:'CDR management',
    serverConfig:'Push configuration',
    serverAddrs:'Platform address',
    serverType:'Platform type',
    serverInfo:'Platform information',
    grant_type:'Client type',
    client_id:'Client Id',
    LoginType:'Login type',
    Client_secret:'Password',
    inputaddr:"Please enter the platform address",
    inputpol:'Domain name:port,for example192.168.120.20:8080',
    call_record:"Call record",
    serverTypevalue:'Dalian police',
    serverjh:'Jinhua police',
    ip:'IP',
    IC:"Internal call(IP to FXS)",
    internal_call:'Internal call(FXS to IP)',
    IP:"Unknown call",
    calltype:"Call type",
    trunkNumber:'Trunk',
    router:"route",
    sipproxy:"Proxy server",
    firmware:"Firmware version",
    sipregistration:'Registration server',
    datetime:"Date and time",
    timerange:"Select time range",
    query:'Caller,Callee,Trunk',
    cpnIP:"Caller IP",
    udpadrrconfig:'Configuring CDR collection',
    localudpaddr:'Local listening port',
    extranet:"External network address",
    deletetip:"Please enter the device MAC address or select a date range.",
    routeip:"IP",
    routexo:"FXO",
    success:"Submit successfully,please restart",
    device_IP:"Equipment extranet IP",
    deviceInf:"Device information",
    lastcontacttime:"Last update time",
    downloadLog:"Download log",
    logtitle:"Log list",
    deviceconfig:"Device config",
    issuetitle:"Send list",
    issuenowtime:"Actual delivery time",
    issuesettime:"Web delivery time",
    issuecontent:"Deliver content",
    callenable:"Call enable",
    forbiddenCall:"Forbidden call",
    calltitle:"Call",
    recordcheck:"Start recording",
    downrecord:"Download recording",
    callverify:"Are you sure you want to call the called number?",
    calltip:"Please enter the called number",
    logtype:"Log type",
    recordlog:"Recording log",
    log:"Log",
    operationTip:"Command",
    waringTip:", please try again later",
    nosend:"not sent",
    sending:"sending",
     caleer:"Callee",
     dellog:"Please select log"
  }
};



// WEBPACK FOOTER //
// ./src/lang/en-us.js